(function (app) {

    var shiftTemplateUtils;
    var brandBusinessDayUtils;
    var teamScheduleService;
    var _TSUsersService;
    var _scheduleDateUtilsService;
    let extraPaySettings = [];
    var _filter;
    var _modal;
    let _specialEventsService;

    /**
     * TeamLive Schedule V2 Data Service - Parse all schedule related data
     * @namespace ScheduleDataServiceV2
     * @constructor
     */
    var ScheduleDataServiceV2 = function () {
        var self = this;

        var TIME_FORMAT= 'YYYY-MM-DD HH:mm:ss';
        var MINUTE = 60 * 1000;
        var HOUR = 60 * MINUTE;
        const DAY = 24 * HOUR;
        var _emitter = JarEventEmitter.call(self);
        var _parLaborData;
        var settings = {};
        let incentiveSettingsMap = {};
        let automaticIncentiveRulesMap = {};
        var isFairSchedulingServiceEnabled;
        var isJustCauseServiceEnabled;
        var isMarkedDaysServiceEnabled;
        var gfeSettings;
        var brandOfferedShifts = {};
        var userPositionsPreferences;
        let isSalliEnabled;
        var teamLiveCountryCode;
        var hasPendingEmployeeConsent;
        var minWeeklyHoursSettings;
        let isShiftAssignmentsAcrossDifferentPositionsEnabled;
        let isWorkingPatternsServiceEnabled = false;
        var crossScheduleBrandIds = [];

        self.flatData = {
            roles: {},
            roleDays: {},
            assignees: {},
            shifts: {},
            users: {},
            days: {},
            publishers: {}
        };

        var schedulePreloadCache = {};

        var cacheKeys = {
            SCHEDULE_SETTINGS: "SCHEDULE_SETTINGS",
            AVAILABILITY_SETTINGS: "AVAILABILITY_SETTINGS",
            BRANDS_LABELS: "BRAND_LABELS",
            LOCK_SETTINGS: "LOCK_SETTINGS",
            MCD_SETTINGS: "MCD_SETTINGS",
        };

        self.scheduleGraphs = {
            WEEKLY_COVERAGE: 'WEEKLY_COVERAGE',
            SALES_GRAPH: 'SALES_GRAPH',
            STATS_TABLE: 'STATS_TABLE',
            KPI_TABLE: 'KPI_TABLE',
            WENDY_TABLE: 'WENDY_TABLE',
            GUIDE_HOURS_TABLE: 'GUIDE_HOURS_TABLE',
            BUDGET_TABLE: 'BUDGET_TABLE',
        };

        const closedReason = {
            PARTIAL_CLOSED_DATE: 'PARTIAL_CLOSED_DATE',
            CLOSED_DATE: 'CLOSED_DATE',
            CLOSED_DAY: 'CLOSED_DAY'
        };

        var scheduleTemplatesCache = {};
        var workingDaysBoundaries = {};
        var philippinesPremiums = {};

        self.brandHolidays = {};
        self.extraDayFlatData = {};
        self.extraCrossDayFlatData = {};
        self.highlightedShiftsIds = [];
        self.isForecastDailyTotalsExpanded = {};
        var nextCalendarWeekShifts = {};
        var shiftsSources = {};
        var previousCalendarWeekShifts = {};
        var userShiftsPerWorkingDays = {};
        var employeeLatenessReasons = {};
        var employeeLatenessReasonPeriod = {};
        self.scheduleWarningsConfiguration = {};
        var dayNotes = {};
        let specialEvents = [];

        self.WORK_LIMIT_HOURS = 48;

        var shiftsChangedTimeout;

        var triggerShiftsChanged = function () {
            clearTimeout(shiftsChangedTimeout);

            shiftsChangedTimeout = setTimeout(function () {
                _emitter.trigger('shifts_changed');
            }, 1);
        };

        var usersChangedTimeout;

        self.triggerUsersChanged = function () {
            clearTimeout(usersChangedTimeout);

            usersChangedTimeout = setTimeout(function () {
                _emitter.trigger('users_changed');
            }, 1);
        };

        self.clearScheduleTemplatesCache = function () {
            scheduleTemplatesCache = {};
        };

        self.setBrandMinWeeklyHoursSettings = function (minWeeklyHours) {
            minWeeklyHoursSettings = minWeeklyHours;

            if (Object.keys(minWeeklyHoursSettings).length) {
                minWeeklyHoursSettings['payTypesCodes'] = _.pluck(minWeeklyHoursSettings['payment_types'], 'paytype');
            }
        };

        self.isPhilippinesMinWeeklyHoursEnabled = function () {
            return (minWeeklyHoursSettings && minWeeklyHoursSettings['value'] > 0);
        };

        self.getBrandMinWeeklyHoursSettings = function () {
            return minWeeklyHoursSettings;
        };

        self.getScheduleTemplatesList = function (brandId) {
            var defer = $q.defer();

            if (scheduleTemplatesCache[brandId]) {
                defer.resolve(angular.copy(scheduleTemplatesCache[brandId]));
            } else {
                TeamScheduleAPI.getScheduleTemplatesList(brandId)
                    .then(function (scheduleTemplates) {
                        scheduleTemplatesCache[brandId] = scheduleTemplates;
                        defer.resolve(angular.copy(scheduleTemplatesCache[brandId]));
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            }
            return defer.promise;
        };

        self.updateScheduleTemplatesCache = function (brandId, scheduleTemplate) {
            var index = scheduleTemplatesCache[brandId]['schedule_templates'].findIndex(function (template) {
                return template.name === scheduleTemplate.name;
            });
            if (index === -1) {
                scheduleTemplatesCache[brandId]['schedule_templates'].push(scheduleTemplate);
            } else {
                scheduleTemplatesCache[brandId]['schedule_templates'][index] = scheduleTemplate;
            }
        };

        self.deleteScheduleTemplateCache = function (brandId, index) {
            scheduleTemplatesCache[brandId]['schedule_templates'].splice(index, 1);
        };

        self.reset = function (scheduleData) {
            self.flatData = {
                roles: {},
                roleDays: {},
                assignees: {},
                shifts: {},
                users: {},
                days: {},
                extended_shifts: {},
                extended_days: {},
                extended_user_shifts: {},
                publishers: {}
            };

            self.extraDayFlatData = {};
            self.extraCrossDayFlatData = {};
            nextCalendarWeekShifts = {};
            previousCalendarWeekShifts = {};
            userShiftsPerWorkingDays = {};
            employeeLatenessReasonPeriod = {};

            delete self.parLabors;
            _parLaborData = null;
            gfeSettings = null;
            isFairSchedulingServiceEnabled = false;
            isJustCauseServiceEnabled = false;
            self.isBlendedRateEnabled = false;
            teamLiveCountryCode = null;
            _forecastDetails = null;
            _forecastedGuideHours = null;
            _forecastedGuideHoursRuleMap = null;
            self.isGuidedhoursDistributionEnabled = false;
            self.isForecastDailyTotalsExpanded = {};
            minWeeklyHoursSettings = null;
            incentiveSettingsMap = {};
            automaticIncentiveRulesMap = {};

            self.originalTemplates = [];
            self.shiftsTemplates = {};
            self.shiftsTemplatesArray = [];
            self.scheduleRoles = [];
            self.selectedScheduleRoles = [];
            self.highlightedShiftsIds = [];

            brandOfferedShifts = {};
            crossScheduleBrandIds = [];
            self.optedInEmployeesMap = {};

            self.mappings = {
                day_role: {}, // roleDay.id
                user_roleday: {}, // assignee.id
                roleday_position: {}, // position object
                day_user: {}, // [assignee_ids]
                position_category: {}
            };

            self.crossFlatData = {};
            self.crossMappings = {};
            self.usersCrossLocationShifts = {};
            self.usersCrossLocationShiftsWeekBefore = {};

            self.scheduleId = scheduleData && scheduleData.id;
            self.brandId = scheduleData && scheduleData.brand_id;
            self.startDate = scheduleData && scheduleData.start_date;
            self.status = scheduleData && scheduleData.status;
            self.editedAfterPublish = scheduleData && scheduleData.is_edited_after_published;
            shiftsSources = {};
            delete self.isBrandUK;
            dayNotes = {};
            self.markedDays = {};
        };

        self.clearCache = function () {
            schedulePreloadCache = {};
        };

        self.getScheduleSettings = function (brandId) {
            var defer = $q.defer();

            if (schedulePreloadCache[brandId] && schedulePreloadCache[brandId][cacheKeys.SCHEDULE_SETTINGS]) {
                defer.resolve(angular.copy(schedulePreloadCache[brandId][cacheKeys.SCHEDULE_SETTINGS]));
            } else {
                TeamScheduleAPI.getScheduleSettings(brandId)
                    .then(function (scheduleSettings) {
                        schedulePreloadCache[brandId] = schedulePreloadCache[brandId] || {}
                        schedulePreloadCache[brandId][cacheKeys.SCHEDULE_SETTINGS] = scheduleSettings;
                        defer.resolve(angular.copy(schedulePreloadCache[brandId][cacheKeys.SCHEDULE_SETTINGS]));
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            }
            return defer.promise;
        };

        const [getBrandUserPreferences, resetBrandUserPrefernces] = cacheService.cache(TeamScheduleAPI.getBrandUserPreferences);

        self.getBrandUserPreferences = getBrandUserPreferences;
        self.resetBrandUserPrefernces = resetBrandUserPrefernces;

        self.getBrandAvailabilitySettings = function (brandId) {
            var defer = $q.defer();

            if (schedulePreloadCache[brandId] && schedulePreloadCache[brandId][cacheKeys.AVAILABILITY_SETTINGS]) {
                defer.resolve(angular.copy(schedulePreloadCache[brandId][cacheKeys.AVAILABILITY_SETTINGS]));
            } else {
                AttendanceAPI.getBrandAvailabilitySettings(brandId)
                    .then(function (availabilitySettings) {
                        schedulePreloadCache[brandId] = schedulePreloadCache[brandId] || {}
                        schedulePreloadCache[brandId][cacheKeys.AVAILABILITY_SETTINGS] = availabilitySettings;
                        defer.resolve(angular.copy(schedulePreloadCache[brandId][cacheKeys.AVAILABILITY_SETTINGS]));
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            }
            return defer.promise;
        };

        self.getBrandLabels = function (brandId) {
            var defer = $q.defer();

            if (schedulePreloadCache[brandId] && schedulePreloadCache[brandId][cacheKeys.BRANDS_LABELS]) {
                defer.resolve(angular.copy(schedulePreloadCache[brandId][cacheKeys.BRANDS_LABELS]));
            } else {
                TeamScheduleV2API.getBrandLabels(brandId)
                    .then(function (labels) {
                        schedulePreloadCache[brandId] = schedulePreloadCache[brandId] || {}
                        schedulePreloadCache[brandId][cacheKeys.BRANDS_LABELS] = labels;
                        defer.resolve(angular.copy(schedulePreloadCache[brandId][cacheKeys.BRANDS_LABELS]));
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            }
            return defer.promise;
        };

        self.getBrandScheduleLockSettings = function (brandId) {
            var defer = $q.defer();

            if (schedulePreloadCache[brandId] && schedulePreloadCache[brandId][cacheKeys.LOCK_SETTINGS]) {
                defer.resolve(angular.copy(schedulePreloadCache[brandId][cacheKeys.LOCK_SETTINGS]));
            } else {
                TeamScheduleAPI.getBrandScheduleLockSettings(brandId)
                    .then(function (lockSettings) {
                        schedulePreloadCache[brandId] = schedulePreloadCache[brandId] || {}
                        schedulePreloadCache[brandId][cacheKeys.LOCK_SETTINGS] = lockSettings;
                        defer.resolve(angular.copy(schedulePreloadCache[brandId][cacheKeys.LOCK_SETTINGS]));
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            }
            return defer.promise;
        };

        self.getMcDSettings = function (brandId) {
            var defer = $q.defer();

            if (schedulePreloadCache[brandId] && schedulePreloadCache[brandId][cacheKeys.MCD_SETTINGS]) {
                defer.resolve(angular.copy(schedulePreloadCache[brandId][cacheKeys.MCD_SETTINGS]));
            } else {
                McDLaborAPI.getMcDSettings(brandId)
                    .then(function (settings) {
                        schedulePreloadCache[brandId] = schedulePreloadCache[brandId] || {}
                        schedulePreloadCache[brandId][cacheKeys.MCD_SETTINGS] = settings || {};
                        defer.resolve(angular.copy(schedulePreloadCache[brandId][cacheKeys.MCD_SETTINGS]));
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            }
            return defer.promise;
        };

        self.setRevenueCenters = function (revenueCenters) {
            self.revenueCenters = {};

            for (var i in revenueCenters) {
                self.revenueCenters[revenueCenters[i].id] = revenueCenters[i];
            }
        };

        self.getEmployeeLatenessReasons = function (brandId) {
            var deferred = $q.defer();

            if (employeeLatenessReasons[brandId]) {
                deferred.resolve(employeeLatenessReasons[brandId]);
            } else {
                TeamScheduleAPI.getLatenessReasons(brandId)
                    .then(function (response) {
                        var reasons = response.reduce(function (reasonsMap, reason) {
                            reasonsMap[reason.id] = reason;
                            return reasonsMap;
                        }, {});
                        employeeLatenessReasons[brandId] = reasons;
                        deferred.resolve(reasons);
                    })
                    .catch(function (error) {
                        console.error(error);
                        deferred.resolve({});
                    });
            }
            return deferred.promise;
        };

        self.setScheduleRoles = function(roles) {
            self.scheduleRoles = roles;
        };

        self.setSelectedScheduleRoles = function() {
            self.selectedScheduleRoles = Object.keys(self.flatData['roles']);
            _emitter.trigger('selected_schedule_roles');
        };

        self.getScheduleRoleCounts = function (viewPreset) {
            self.scheduleRolesCount = self.scheduleRolesCount || {};
            self.selectedScheduleRolesCount = self.selectedScheduleRolesCount || {};

            var positionCodes = _.pluck(viewPreset.positions, 'code');

            if (!self.scheduleRolesCount[viewPreset.id]) {
                if (viewPreset.id !== 'MAIN') {
                    var filteredRoles = self.scheduleRoles.filter(function (position) {
                        return positionCodes.indexOf(position.position.code) > -1;
                    });
                    self.scheduleRolesCount[viewPreset.id] = filteredRoles.length;
                } else {
                    self.scheduleRolesCount[viewPreset.id] = self.scheduleRoles.length;
                }
            }

            if (viewPreset.id !== 'MAIN') {
                var filteredSelectedRoles = self.scheduleRoles.filter(function (position) {
                    return (
                        positionCodes.indexOf(position.position.code) > -1
                            && position.id
                        && self.selectedScheduleRoles.indexOf(position.id.toString()) > -1
                    );
                });
                self.selectedScheduleRolesCount[viewPreset.id] = filteredSelectedRoles && filteredSelectedRoles.length || 0;
            } else {
                self.selectedScheduleRolesCount[viewPreset.id] = self.selectedScheduleRoles.length;
            }

            return {
                scheduleRoles: self.scheduleRolesCount[viewPreset.id],
                selectedScheduleRoles: self.selectedScheduleRolesCount[viewPreset.id]
            };
        }

        self.setJobTitlesListType = function(type) {
         self.jobTitlesListType = type;
        };

        self.setBrandJobTitles = function (jobTiles) {
            self.brandJobTiles = {};

            for (var i in jobTiles) {
                var color = jobTiles[i].color || '#FFFFFF';
                jobTiles[i].text_color = Utils.getPreferredTextColor(color);
                self.brandJobTiles[jobTiles[i].id] = jobTiles[i];
            }
        };

        self.setUsersJobTiles = function (usersJobTiles) {
            self.usersJobTiles = {};

            for (var i in usersJobTiles) {
                var userDetails = usersJobTiles[i];
                var userJobTitlesMap = {};

                for (var j in userDetails["user_brand_job_titles"]) {
                    var userJobTiles = userDetails["user_brand_job_titles"][j];
                    var jobTitle = {id: userJobTiles["job_title"].id, level: userJobTiles.level, name: userJobTiles["job_title"].name};

                    userJobTitlesMap[jobTitle.id] = jobTitle;
                }

                self.usersJobTiles[userDetails.id] = userJobTitlesMap;
            }
        };

       self.prepareOptedInEmployeesMap = function (brandId, startDate) {
            self.optedInEmployeesMap = {};
            var offeredShifts = brandOfferedShifts[brandId + '_' + startDate];

            for (var i in offeredShifts) {
                var offeredShift = offeredShifts[i];

                if (offeredShift['destination_assignee_shift']) {
                    var shiftId = offeredShift['destination_assignee_shift']['unpublished_assignee_shift_id'];
                    var userId = offeredShift['to_user_id'];

                    if (offeredShift['is_unassigned_vsl_offeree_opted_in']) {
                        self.optedInEmployeesMap[shiftId + "_" + userId] = true;
                    }
                }
            }
        };

        self.setBrandShiftsOffers = function (offeredShifts, brandId, startDate) {
            brandOfferedShifts[brandId + '_' + startDate] = offeredShifts['offers'] || [];
        };

        self.getBrandShiftsOffers = function (brandId, startDate) {
            var defer = $q.defer();

            if (brandOfferedShifts[brandId + '_' + startDate]) {
                defer.resolve(angular.copy(brandOfferedShifts[brandId + '_' + startDate]));
            } else {
                TeamScheduleV2API.getUsersOfferedShifts(brandId, startDate)
                    .then(function (offeredShifts) {
                        brandOfferedShifts[brandId + '_' + startDate] = offeredShifts['offers'] || [];
                        defer.resolve(angular.copy(offeredShifts['offers'] || []));
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    });
            }
            return defer.promise;
        };

        self.setLabels = function (labels) {
            self.labels = {};
            for (var i in labels) {
                self.labels[labels[i].id] = labels[i];
            }
        };

        self.setDayParts = function (dayParts, selectedDay) {
            var rawDayParts = angular.copy(dayParts);
            self.dayParts = [];
            var utcDayOpenTime = self.dayOpenHour + new Date(selectedDay).getHours() * HOUR +  new Date(selectedDay).getMinutes() * MINUTE;

            for (var i in rawDayParts) {
                if (rawDayParts[i].status === 'ACTIVE') {
                    rawDayParts[i].original_start_time = rawDayParts[i].start_time;
                    rawDayParts[i].original_end_time = rawDayParts[i].end_time;
                    rawDayParts[i].start_time = new Date(rawDayParts[i].start_time).getHours() * HOUR + new Date(rawDayParts[i].start_time).getMinutes() * MINUTE;
                    rawDayParts[i].end_time = new Date(rawDayParts[i].end_time).getHours() * HOUR + new Date(rawDayParts[i].end_time).getMinutes() * MINUTE;
                    rawDayParts[i].color = "#63f3a0";

                    if (rawDayParts[i].start_time < utcDayOpenTime) {
                        rawDayParts[i].start_time += 24 * 60 * 60 * 1000; // One day shift
                    }

                    if (rawDayParts[i].end_time <= utcDayOpenTime) {
                        rawDayParts[i].end_time += 24 * 60 * 60 * 1000; // One day shift
                    }

                    self.dayParts.push(rawDayParts[i]);
                }
            }

            self.dayParts.sort((a, b) => a.start_time - b.start_time);
        };

        self.setTeamLiveCountryCode = function (CountryCode) {
            teamLiveCountryCode = CountryCode;
        };

        self.setIsSalliEnabled = (enabled) => {
            isSalliEnabled = enabled;
        };

        self.getIsSalliEnabled = () => {
            return isSalliEnabled;
        };

        self.getTeamLiveCountryCode = function () {
            return teamLiveCountryCode;
        };

        self.getBrandStartDayOfWeek = function () {
            var brand = teamScheduleService.getBrandById(self.brandId);
            return brand.startDayOfWeek;
        };

        self.getFilteredUserIds = function (selectedDate, filters) {
            var filteredUserIds = [];

            for (var i in self.flatData['shifts']) {
                var slot = self.flatData['shifts'][i];
                var position = self.flatData['roles'][slot.role_id]['position'];

                if (filters && filters.position_codes.length && filters.position_codes.indexOf(position.code) === -1) {
                    continue;
                }

                if (filters && filters.category_codes.length && filters.category_codes.indexOf(position.category.code) === -1) {
                    continue;
                }

                if (filters && filters.user_ids.length && filters.user_ids.indexOf(slot.user_id) === -1) {
                    continue;
                }

                if (filters && filters.show_unassigned_only && slot.user_id) {
                    continue;
                }

                if (filters && filters.unassigned_shift_type) {
                    if (['ONCE', 'FOREVER'].indexOf(filters.unassigned_shift_type.code) > -1) {
                        if (slot.forecasted_recurrence !== filters.unassigned_shift_type.code) {
                            continue;
                        }
                    } else {
                        var shiftsSources= self.getShiftSources();
                        if (shiftsSources[slot.id] !== 'LOCATION_PERIOD_CHANGE_WITH_MASS_COMMS') {
                            continue;
                        }
                    }
                }

                if (filters && filters.publish_status.length) {
                    var shiftStatus = ['PARTIALLY_PUBLISHED', 'UNPUBLISHED', 'DELETED', 'PUBLISHED_EDITED'].indexOf(slot.status) > -1 ? 'UNPUBLISHED' : slot.status;

                    if (filters.publish_status.indexOf(shiftStatus) === -1) {
                        continue;
                    }
                }

                if (filters && filters.day_part_ids.length) {
                    var doesShiftOverlapAny = false;

                    for (var dp in filters.day_part_ids) {
                        var dayPartObject = _.findWhere(self.dayParts, {id: filters.day_part_ids[dp]});

                        if (self.shiftDayPartOverlap(selectedDate, slot, dayPartObject)) {
                            doesShiftOverlapAny = true;
                            break;
                        }
                    }

                    if (!doesShiftOverlapAny) {
                        continue;
                    }
                }

                if (filters && filters.revenue_center_ids.length) {
                    var doesShiftApplyAny = false;

                    for (var rc in filters.revenue_center_ids) {
                        var revenueCenterObject = _.findWhere(self.revenueCenters, {id: filters.revenue_center_ids[rc]});
                        if (slot.revenue_center_id == revenueCenterObject.id) {
                            doesShiftApplyAny = true;
                            break;
                        }
                    }

                    if (!doesShiftApplyAny) {
                        continue;
                    }
                }

                if (filters && filters.job_titles_ids && filters.job_titles_ids.length) {
                    var doesShiftApply = false;

                    for (var jobTitleIndex in slot.job_titles) {
                        if (filters.job_titles_ids.indexOf(slot.job_titles[jobTitleIndex].job_title_id) > -1) {
                            doesShiftApply = true;
                            break;
                        }
                    }

                    if (!doesShiftApply) {
                        continue;
                    }
                }

                if (filters && filters.label_ids.length) {
                    var doesShiftApply = false;

                    for (var label in filters.label_ids) {
                        var labelObject = _.findWhere(self.labels, {id: filters.label_ids[label] && filters.label_ids[label]});

                        if (slot.labels && (slot.labels.indexOf(labelObject.id) > -1 || (!slot.labels.length && !labelObject.id))) {
                            doesShiftApply = true;
                            break;
                        }
                    }

                    if (!doesShiftApply) {
                        continue;
                    }
                }

                filteredUserIds.push(slot.user_id);
            }

            for (var i in self.flatData['users']) {
                var userData = self.flatData['users'][i];

                if (userData.id && userData.shift_ids.length === 0) {
                    var positionApplied = !filters || !filters.position_codes.length;
                    var categoryApplied = !filters || !filters.category_codes.length;

                    if (filters && filters.user_ids.length && filters.user_ids.indexOf(userData.id) === -1) {
                        continue;
                    }

                    if (filters && (filters.position_codes.length || filters.category_codes.length)) {
                        for (var r in userData['role_ids']) {
                            var role = self.flatData['roles'][userData['role_ids'][r]] || {};
                            var position = role['position'];

                            if (filters && filters.position_codes.length && filters.position_codes.indexOf(position.code) > -1) {
                                positionApplied = true;
                                break
                            }

                            if (filters && filters.category_codes.length && filters.category_codes.indexOf(position.category.code) > -1) {
                                categoryApplied = true;
                                break
                            }
                        }
                    }

                    if (!positionApplied && !categoryApplied) {
                        continue;
                    }

                    filteredUserIds.push(userData.id);
                }
            }

            return _.uniq(filteredUserIds);
        };

        self.reformatScheduleFilters = function (filters, schedulePreset) {
            var formattedFilters = {
                user_ids: [],
                category_codes: [],
                position_codes: [],
                revenue_center_ids: [],
                job_titles_ids: [],
                label_ids: [],
                day_part_ids: [],
                unassigned_shift_type: undefined,
                publish_status: [],
                show_unassigned_only: false
            };

            if (filters.positions) {
                formattedFilters.position_codes = _.pluck(filters.positions, 'code');
            } else if (schedulePreset && schedulePreset.id !== 'MAIN') {
                formattedFilters.position_codes = _.pluck(schedulePreset['positions'], 'code');
            }

            if (filters.categories) {
                formattedFilters.category_codes = _.pluck(filters.categories, 'code');
            }

            if (filters.user) {
                formattedFilters.user_ids = [filters.user.id];
            }

            if (filters.show_unassigned_only) {
                formattedFilters.show_unassigned_only = filters.show_unassigned_only;

                if (filters.unassigned_shift_type) {
                    formattedFilters.unassigned_shift_type = filters.unassigned_shift_type.code;
                }
            }

            if (filters.day_part) {
                formattedFilters.day_part_ids = [filters.day_part.id];
            }

            if (filters.revenue_center) {
                formattedFilters.revenue_center_ids = [filters.revenue_center.id];
            }

            if (filters.job_titles) {
                formattedFilters.job_titles_ids = _.pluck(filters.job_titles, 'id');
            }

            if (filters.label) {
                formattedFilters.label_ids = [filters.label.id];
            }

            if (filters.publish_status) {
                formattedFilters.publish_status = [filters.publish_status.id];
            }

            return formattedFilters;
        };

        self.reformatPublishFilters = function (schedulePublishFilters, schedulePreset) {
            var publishFilters = angular.copy(schedulePublishFilters);

            if (schedulePublishFilters['category_codes']) {
                publishFilters.category_codes = _.pluck(schedulePublishFilters['category_codes'], 'code');
            }

            if (schedulePublishFilters['user_ids']) {
                publishFilters['user_ids'] = [];

                for (var x in schedulePublishFilters['user_ids']) {

                    publishFilters['user_ids'].push(
                        schedulePublishFilters.user_ids[x].id
                    )
                }
            }

            if (schedulePublishFilters['position_codes'] && schedulePublishFilters['position_codes'].length) {

                publishFilters['position_codes'] = [];

                for (var i in schedulePublishFilters['position_codes']) {

                    publishFilters['position_codes'].push(
                        schedulePublishFilters.position_codes[i].code
                    )
                }
            } else if (schedulePreset && schedulePreset.id !== 'MAIN') {
                publishFilters['position_codes'] = _.pluck(schedulePreset['positions'], 'code');
            }

            if (schedulePublishFilters['revenue_center_ids'] && schedulePublishFilters['revenue_center_ids'].length) {
                publishFilters['revenue_center_ids'] = [];

                for (var y in schedulePublishFilters['revenue_center_ids']) {

                    publishFilters['revenue_center_ids'].push(
                        schedulePublishFilters.revenue_center_ids[y].id
                    )
                }
            }

            if (schedulePublishFilters['job_titles_ids'] && schedulePublishFilters['job_titles_ids'].length) {
                publishFilters['job_titles_ids'] = [];

                for (var j in schedulePublishFilters['job_titles_ids']) {

                    publishFilters['job_titles_ids'].push(
                        schedulePublishFilters.job_titles_ids[j].id
                    )
                }
            }

            if (schedulePublishFilters['unassigned_shift_type']) {
                publishFilters['unassigned_shift_type'] = schedulePublishFilters['unassigned_shift_type'];
            }

            if (schedulePublishFilters['label_ids'] && schedulePublishFilters['label_ids'].length) {
                publishFilters['label_ids'] = [];

                for (var l in schedulePublishFilters['label_ids']) {

                    publishFilters['label_ids'].push(
                        schedulePublishFilters.label_ids[l].id
                    )
                }
            }

            if (schedulePublishFilters['day_part_ids'] && schedulePublishFilters['day_part_ids'].length) {
                publishFilters['day_part_ids'] = [];

                for (var a in schedulePublishFilters['day_part_ids']) {

                    publishFilters['day_part_ids'].push(
                        schedulePublishFilters.day_part_ids[a].id
                    )
                }
            }

            if (schedulePublishFilters['publish_status'] && schedulePublishFilters['publish_status'].length) {
                publishFilters['publish_status'] = [];

                for (var p in schedulePublishFilters['publish_status']) {

                    publishFilters['publish_status'].push(
                        schedulePublishFilters.publish_status[p].id
                    )
                }
            }

            return publishFilters;
        };

        self.checkIfHasFiltersApplied = function (filters) {
            return (
                filters.user_ids.length ||
                filters.position_codes.length ||
                filters.day_part_ids.length ||
                filters.revenue_center_ids.length ||
                filters.job_titles_ids.length ||
                filters.category_codes.length ||
                filters.publish_status.length ||
                filters.label_ids.length ||
                filters.show_unassigned_only ||
                filters.unassigned_shift_type ||
                !filters.show_overlapped_only
            );
        };

        self.shiftDayPartOverlap = (selectedDay, shift, dayPart, compareWithShiftStartTimeOnly, isExtendedShift) => {
            const shiftStartTime = isExtendedShift ? moment(shift.calculatedStart).format("MMM DD, YYYY HH:mm") : shift.start_time;
            const shiftEndTime = isExtendedShift ? moment(shift.calculatedEnd).format("MMM DD, YYYY HH:mm") : shift.end_time;

            const shiftTime = shiftTemplateUtils.getIntervalTime(self.dayOpenHour, {start_time: shiftStartTime, end_time: shiftEndTime});
            const dayPartTime = shiftTemplateUtils.getIntervalTime(self.dayOpenHour, {start_time: dayPart.original_start_time, end_time: dayPart.original_end_time});

            if (compareWithShiftStartTimeOnly) {
                if (shift.isExtendedFromPreviousDay || shift.isExtendedFromPreviousWeek) {
                    return false;
                } else {
                    return (shiftTime.start_time >= dayPartTime.start_time && shiftTime.start_time < dayPartTime.end_time);
                }
            }

            return shiftTime.start_time < dayPartTime.end_time && shiftTime.end_time > dayPartTime.start_time;
        };

        self.checkIfShowShiftRecurrence = function (showShiftRecurrenceLabel) {
            self.showShiftRecurrenceLabel = showShiftRecurrenceLabel;
        }

        self.setBusinessDay = function (selectedDay, businessDays) {
            var selectedDayTime = new Date(selectedDay).getTime();
            self.businessDays = businessDays || self.businessDays;

            for (var i in self.businessDays) {
                var businessDayTime = moment(self.businessDays[i].start_date, "YYYY-MM-DD").valueOf();

                if (selectedDayTime >= businessDayTime) {
                    self.businessDay = self.businessDays[i];
                    break;
                }
            }

            self.dayOpenHour = self.businessDay? self.businessDay.open_time * 1000: 0; // From seconds to millis
            self.dayCloseHour = self.businessDay? self.businessDay.close_time * 1000: 0; // From seconds to millis
            self.dayCloseHourExtension = self.businessDay ? self.businessDay.close_time_extension * 1000 : 0;

            if (self.dayCloseHour <= self.dayOpenHour) {
                self.dayCloseHour += 24 * 60 * 60 * 1000; // One day shift
            }
        };
        var getDateForSpecificDayInWeek = function (date, dayCode) {
            for (var i = 0; i < 7; i++) {
                var weekDay = moment(date).clone().add(i, "days");
                var day = weekDay.format("ddd").toUpperCase();
                if (day === dayCode) {
                    return weekDay;
                }
            }    
        }

        self.getMissingCalendarWorkingDaysBoundaries = function (scheduleStartDate, brandStartDay) {
            var previousWeekParams = {};
            var nextWeekParams = {};
            var nextWeekStartDateTime = moment(scheduleStartDate).clone();
            var currentWeekStartDateTime = moment(scheduleStartDate).clone();
            var maxScheduleDaySettings = settings['schedule'] && settings['schedule']['max_scheduled_days'] || {};
            var scheduleMaxWorkingDaysWeekType = maxScheduleDaySettings['schedule_max_working_days_week_type'];
            var calendarStartDay = maxScheduleDaySettings['calendar_start_day'];
            var brandHasTimeExtension = self.businessDay['close_time_extension'] > 0;

            var duration = moment.duration(self.dayOpenHour);
            var hours = duration.hours();
            var minutes = duration.minutes();

            currentWeekStartDateTime.set('hour', hours).set('minute', minutes);
            nextWeekStartDateTime.add(1, 'week').set('hour', hours).set('minute', minutes);

            if (scheduleMaxWorkingDaysWeekType === 'BUSINESS') {
                if (brandHasTimeExtension) {
                    return {
                        previousWeekParams: {
                            start_time: moment(scheduleStartDate).clone().subtract(1, 'd').format('YYYY-MM-DDTHH:mm:ss'),
                            end_time: moment(scheduleStartDate).clone().format('YYYY-MM-DDTHH:mm:ss')
                        },
                        nextWeekParams: {}
                    }
                }
                return {
                    previousWeekParams: {},
                    nextWeekParams: {}
                }
            }

            if (calendarStartDay === brandStartDay) {
                if (!(self.businessDay['close_time'] === 0 && self.businessDay['open_time'] === 0)) {
                    var nextWeekEndDate = nextWeekStartDateTime.clone().add(1, 'w').startOf('day');

                    previousWeekParams = {
                        start_time: moment(scheduleStartDate).clone().format('YYYY-MM-DDTHH:mm:ss'),
                        end_time: currentWeekStartDateTime.format('YYYY-MM-DDTHH:mm:ss')
                    }
                    nextWeekParams = {
                        start_time: nextWeekStartDateTime.format('YYYY-MM-DDTHH:mm:ss'),
                        end_time: nextWeekEndDate.format('YYYY-MM-DDTHH:mm:ss')
                    }
                    setCalenderWorkingDaysBoundaries(scheduleStartDate, nextWeekStartDateTime.format('YYYY-MM-DD'))
                }
            } else {
                var calenderDayInCurrentWeek = getDateForSpecificDayInWeek(scheduleStartDate, calendarStartDay);
                var calenderDayInNextWeek = calenderDayInCurrentWeek.clone().add(7, "days").startOf('day');
                var calenderDayInPreviousWeek = calenderDayInCurrentWeek.clone().subtract(7, "days").startOf('day');
                previousWeekParams = {
                    start_time: calenderDayInPreviousWeek.format('YYYY-MM-DDTHH:mm:ss'),
                    end_time: currentWeekStartDateTime.format('YYYY-MM-DDTHH:mm:ss')
                }
                nextWeekParams = {
                    start_time: nextWeekStartDateTime.format('YYYY-MM-DDTHH:mm:ss'),
                    end_time: calenderDayInNextWeek.format('YYYY-MM-DDTHH:mm:ss')
                }
                setCalenderWorkingDaysBoundaries(calenderDayInPreviousWeek.format('YYYY-MM-DD'), calenderDayInCurrentWeek.format('YYYY-MM-DD'))
            }

            if (brandHasTimeExtension) {
                var startDate = previousWeekParams.start_time || currentWeekStartDateTime;
                previousWeekParams = {
                    start_time: moment(startDate).clone().subtract(1, 'd').format('YYYY-MM-DDTHH:mm:ss'),
                    end_time: currentWeekStartDateTime.format('YYYY-MM-DDTHH:mm:ss')
                };
            }

            return {
                previousWeekParams: previousWeekParams,
                nextWeekParams: nextWeekParams
            }
        }

        self.getShiftDay = function (shift) {
            var shiftStartDate = new Date(shift['start_time']);
            var shiftStartHour = shiftStartDate.getHours() * HOUR + shiftStartDate.getMinutes() * MINUTE;

            var brandId = shift['brand_id'] || self.brandId;
            var shiftDay = shift['day'] || moment(shift['start_time']).format("MMM DD, YYYY");
            var businessDay = teamScheduleService.getBusinessDay(shiftDay, brandId);
            var openTime = businessDay ? businessDay['open_time'] : self.dayOpenHour;

            if (shiftStartHour < openTime) {
                shiftStartDate = shiftStartDate.getTime() - (24 * HOUR);
            }

            return moment(shiftStartDate).format("MMM DD, YYYY");
        };

        self.updateParLaborData = function () {

            delete self.parLabors;

            if (_parLaborData) {
                self.parLabors = {};

                for (var i in _parLaborData.days) {
                    var parLaborDay = _parLaborData.days[i];

                    self.parLabors[parLaborDay.day] = {positions: {}, day: parLaborDay.day, categories: {}, has_day_parts: true};

                    for (var j in parLaborDay.position_par_forecasts) {
                        var positionPar = parLaborDay.position_par_forecasts[j];
                        var category = self.mappings['position_category'][positionPar.position.code];

                        // If position is not added to the schedule yet, mapping will not get the category (category is undefined)
                        // If the position is added, this will be called again
                        if (category) {
                            self.parLabors[parLaborDay.day].positions[positionPar.position.code] = { day_parts: {}, total: 0 };
                            self.parLabors[parLaborDay.day].categories[category.code] = self.parLabors[parLaborDay.day].categories[category.code] || { day_parts: {}, total: 0, has_day_parts: true };

                            for (var k in positionPar.day_parts) {
                                var dayPart = positionPar.day_parts[k];
                                self.parLabors[parLaborDay.day].positions[positionPar.position.code].day_parts[dayPart.day_part && dayPart.day_part.name] = dayPart.number_of_shifts;
                                self.parLabors[parLaborDay.day].positions[positionPar.position.code].total += dayPart.number_of_shifts;

                                self.parLabors[parLaborDay.day].categories[category.code].day_parts[dayPart.day_part && dayPart.day_part.name] = self.parLabors[parLaborDay.day].categories[category.code].day_parts[dayPart.day_part && dayPart.day_part.name] || 0;
                                self.parLabors[parLaborDay.day].categories[category.code].day_parts[dayPart.day_part && dayPart.day_part.name] += dayPart.number_of_shifts;
                                self.parLabors[parLaborDay.day].categories[category.code].total += dayPart.number_of_shifts;

                                self.parLabors[parLaborDay.day].positions[positionPar.position.code].has_day_parts = !!dayPart.day_part;
                                self.parLabors[parLaborDay.day].has_day_parts = self.parLabors[parLaborDay.day].has_day_parts && dayPart.day_part;
                                self.parLabors[parLaborDay.day].categories[category.code].has_day_parts = self.parLabors[parLaborDay.day].categories[category.code].has_day_parts && dayPart.day_part;
                            }
                        }
                    }
                }
            }
        };

        self.setParLabors = function (parLabors) {
            _parLaborData = parLabors;
        };

        self.setHasPendingEmployeeConsents = function (value) {
            hasPendingEmployeeConsent = value;
        };

        self.checkIfHasPendingEmployeeConsents = function () {
            return hasPendingEmployeeConsent;
        };

        self.checkTimeZoneOffsetDifference = function (dayOpenTime, dayCloseTime, timezoneName) {
            var dayOpenOffset = moment.tz(moment(dayOpenTime).format('YYYY-MM-DD HH:mm'), timezoneName)._offset;
            var dayCloseOffset = moment.tz(moment(dayCloseTime).format('YYYY-MM-DD HH:mm'), timezoneName)._offset;

            return dayOpenOffset !== dayCloseOffset;
        };

        self.clearUserShifts = function (userId, day) {
            var shiftsToDelete = self.flatData['users'][userId].shift_ids;
            var idsToDelete = [];

            for (var j in shiftsToDelete) {
                var shift = self.flatData['shifts'][shiftsToDelete[j]];

                if (!day || day == shift.day) {
                    // Don't delete immediately, as this will affect the loop on user['shift_ids'] array
                    idsToDelete.push(shiftsToDelete[j]);
                }
            }

            for (var i in idsToDelete) {
                self.deleteShift(idsToDelete[i]);
            }
        };

        self.clearAssigneeShifts = function (assigneeId) {
            var shiftsToDelete = [];
            var assignee = self.flatData['assignees'][assigneeId];

            for (var i in assignee.assignee_shifts) {
                var shift = assignee.assignee_shifts[i];

                if (!shift.isExtendedFromPreviousDay) {
                    shiftsToDelete.push(shift.id);
                }
            }

            for (var j in shiftsToDelete) {
                self.deleteShift(shiftsToDelete[j]);
            }
        };

        self.publishAssignees = function (assigneeIds) {
            for (var a in assigneeIds) {
                self.flatData['assignees'][assigneeIds[a]]['status'] = "PUBLISHED";
            }
        };

        self.deleteAssignee = function (assigneeId, keepShifts) {
            if (self.flatData['assignees'][assigneeId]) {
                var assignee = self.flatData['assignees'][assigneeId];
                var assigneeShifts = angular.copy(assignee.assignee_shifts);
                var role = self.flatData['roles'][assignee.role_id];
                var user = self.flatData['users'][assignee.user_id];
                var userAssigneeIds = user['assignee_ids'] || [];
                var roleDay = self.flatData['roleDays'][assignee.roleday_id];
                var dayData = self.flatData['days'][roleDay.date];
                var unassignedId = self.mappings['user_roleday']['null_' + assignee.roleday_id];
                var shiftsToKeep = [];

                for (var i in assigneeShifts) {
                    var shift = assigneeShifts[i];

                    if (!keepShifts) {
                        self.deleteShift(shift.id);
                    }
                    else {
                        shift.assignee_id = unassignedId;
                        shift.user_id = null;
                        shiftsToKeep.push(shift);
                    }
                }

                if (keepShifts && shiftsToKeep.length) {
                    var unassigned = self.flatData['assignees'][unassignedId];
                    unassigned.assignee_shifts = unassigned.assignee_shifts.concat(shiftsToKeep);
                    triggerShiftsChanged();
                }

                if (role.assignee_ids.indexOf(assignee.id) > -1) {
                    role.assignee_ids.splice(role.assignee_ids.indexOf(assignee.id), 1);
                }

                if (user.assignee_ids.indexOf(assigneeId) > -1) {
                    user.assignee_ids.splice(user.assignee_ids.indexOf(assignee.id), 1);
                }

                var assigneeOnSameRole = _.find(userAssigneeIds, function (userAssigneeId) {
                    var assignee = self.flatData['assignees'][userAssigneeId];
                    return (userAssigneeId !== assigneeId) && assignee && (assignee['role_id'] === role.id);
                });

                if (!assigneeOnSameRole && role.user_ids.indexOf(assignee.user_id) > -1) {
                    role.user_ids.splice(role.user_ids.indexOf(assignee.user_id), 1);
                }

                if (!assigneeOnSameRole && user.role_ids.indexOf(role.id) > -1) {
                    user.role_ids.splice(user.role_ids.indexOf(role.id, 1));
                }

                for (var j in roleDay.assignees) {
                    if (roleDay.assignees[j].id == assignee.id) {
                        roleDay.assignees.splice(j, 1);
                        break;
                    }
                }

                if (user.roleday_ids.indexOf(roleDay.id) > -1) {
                    user.roleday_ids.splice(user.roleday_ids.indexOf(roleDay.id), 1);
                }

                if (self.mappings['day_user'][roleDay.date + '_' + user.id].indexOf(assigneeId) > -1) {
                    self.mappings['day_user'][roleDay.date + '_' + user.id].splice(self.mappings['day_user'][roleDay.date + '_' + user.id].indexOf(assigneeId), 1);
                }

                if (!self.mappings['day_user'][roleDay.date + '_' + user.id].length) {
                    delete self.mappings['day_user'][roleDay.date + '_' + user.id];
                    if (dayData.user_ids.indexOf(user.id) > -1) {
                        dayData.user_ids.splice(dayData.user_ids.indexOf(user.id), 1);
                    }
                    else {
                        console.warn("Couldn't find user info while deleting assignee: assignee_id", assigneeId, "user_id", user.id);
                    }
                }

                if (self.mappings['user_roleday'][user.id + '_' + roleDay.id] === assigneeId) {
                    delete self.mappings['user_roleday'][user.id + '_' + roleDay.id];
                }

                delete self.flatData['assignees'][assigneeId];

                if (!user.assignee_ids.length) {
                    delete self.flatData['users'][user.id];
                }
            }
        };

        self.removeDeleted = function (shiftsIds) {
            var shiftsDeleted = false;

            for (var i in shiftsIds) {
                var shift = self.flatData['shifts'][shiftsIds[i]];

                if (shift && shift.status === 'DELETED' && !self.isShiftBeforeCurrentBrandTimezone(shift)) {
                    self.deleteShift(shift.id, true);
                    shiftsDeleted = true;
                }
            }

            if (shiftsDeleted) {
                triggerShiftsChanged();
            }
        };

        self.deleteShift = function (shiftId, dontNotify) {
            if (self.flatData['shifts'][shiftId]) {
                var shift = self.flatData['shifts'][shiftId];
                var assignee = self.flatData['assignees'][shift.assignee_id];
                var user = self.flatData['users'][shift.user_id];

                for (var i in assignee.assignee_shifts) {
                    var assigneeShift = assignee.assignee_shifts[i];
                    if (assigneeShift.id == shift.id) {
                        assignee.assignee_shifts.splice(i, 1);
                        break;
                    }
                }

                user['shift_ids'].splice(user['shift_ids'].indexOf(shift.id), 1);

                if (self.flatData['extended_shifts'] && self.flatData['extended_shifts'][shiftId]) {
                    var extendedShift = self.flatData['extended_shifts'][shiftId];
                    var extendedDay = self.flatData['extended_days'][extendedShift['extendedDay']];
                    var shiftIndex = _.findIndex(extendedDay['shifts'], {id: extendedShift['id']});

                    if (shiftIndex > -1) {
                        extendedDay['shifts'].splice(shiftIndex, 1);
                    }

                    delete self.flatData['extended_shifts'][shiftId];
                }

                delete self.flatData['shifts'][shiftId];
                !dontNotify && triggerShiftsChanged();
            }
        };

        var updatePublishDetailsForShift = function (shiftData, publishDetails) {
            shiftData.status = "PUBLISHED";

            if (publishDetails) {
                const { published_by, published_time } = publishDetails;

                shiftData.published_by = published_by;
                shiftData.exposure_time = published_time;
                shiftData.earliest_published_by = shiftData.earliest_published_by || published_by;
                shiftData.earliest_published_time = shiftData.earliest_published_time || published_time;
            }

            return shiftData;
        }

        self.updatePublishedShiftsDetails = function (shiftIds, publishDetails) {
            for (var x in shiftIds) {
                if (!self.isShiftBeforeCurrentBrandTimezone(self.flatData['shifts'][shiftIds[x]])) {
                    self.flatData['shifts'][shiftIds[x]] = updatePublishDetailsForShift(self.flatData['shifts'][shiftIds[x]], publishDetails);

                    if (self.flatData['extended_shifts'] && self.flatData['extended_shifts'][shiftIds[x]]) {
                        self.flatData['extended_shifts'][shiftIds[x]] = updatePublishDetailsForShift(self.flatData['extended_shifts'][shiftIds[x]], publishDetails);
                    }
                }
            }
        };

        self.unPublishShifts = function (shiftIds) {
            for (var x in shiftIds) {
                self.flatData['shifts'][shiftIds[x]]['status'] = "UNPUBLISHED";
            }
        };

        self.restoreShift = function () {
            triggerShiftsChanged();
        };

        var convertSecondsToHumanFormat = function(miliSeconds) {
            var fullHours = miliSeconds / (60 * 60 * 1000);
            var hours = Math.floor(fullHours);
            var minutes = Math.round((((fullHours * 100) % 100) / 100) * 60);

            if (hours < 10) {
                hours = '0' + hours;
            }

            if (minutes < 10) {
                minutes = '0' + minutes;
            }

            return hours + ":" + minutes;
        };

        let _forecastDetails, _absSettings, _forecastedGuideHours, _forecastedGuideHoursRuleMap;
        var _nonServiceWendysLaborForecast;
        var _nonServiceActiveRuleMap;

        self.parseForecastedLabor = function (isABSServiceEnabled, forecastDetails, absSettings, forecastedGuideHours, forecastedGuideHoursRuleMap) {
            self.isABSServiceEnabled = isABSServiceEnabled;

            if (forecastDetails && forecastDetails['labor_forecast_days'] && forecastDetails['labor_forecast_days'].length) {
                _forecastDetails = forecastDetails;
            }

            _absSettings = absSettings;
            if (forecastedGuideHours && forecastedGuideHours.id) {
                _forecastedGuideHours = forecastedGuideHours;
                _forecastedGuideHoursRuleMap = forecastedGuideHoursRuleMap;
                self.isGuidedhoursDistributionEnabled = forecastedGuideHours?.templates?.findIndex((template) => {
                    return template.enable_hours_distribution;
                }) !== -1;
            }
        };

        self.parseWendysForecastedLabor = function (isWendysLaborServiceEnabled, wendysLabor, nonServiceWendysLabor, nonServiceActiveRuleMap) {
            self.isWendysLaborServiceEnabled = isWendysLaborServiceEnabled;

            if (wendysLabor && wendysLabor['service_labor_forecast_days'] && wendysLabor['service_labor_forecast_days'].length) {
                var forecastedLaborDays = angular.copy(wendysLabor['service_labor_forecast_days']);
                var positions = [forecastedLaborDays[0]['intervals'][0]['position']];

                for (var i in forecastedLaborDays) {
                    var forecastedDay = forecastedLaborDays[i];

                    for (var j in forecastedDay['intervals']) {
                        var interval = forecastedDay['intervals'][j];
                        interval.positions = [{code: interval['position']['code'], man_power_value: interval['man_power']}];
                    }
                }

                _forecastDetails = {positions: positions, labor_forecast_days: forecastedLaborDays};
                _nonServiceWendysLaborForecast = nonServiceWendysLabor['non_service_labor_forecasts'] || {};
            }

            if (self.isWendysLaborServiceEnabled) {
                _absSettings = {time_interval: 1800};
                _nonServiceActiveRuleMap = nonServiceActiveRuleMap;
            }
        };

        self.setMcdServiceSettings = function (isMcDLaborServiceEnabled) {
            self.isMcDLaborServiceEnabled = isMcDLaborServiceEnabled;
        };

        self.setSpecialEvents = function (events) {
            specialEvents = events;
        };

        self.getCallInsMinDays = function () {
            return {
                CA: 2,
                CT: 2,
                DC: 4,
                MA: -1,
                NH: 2,
                NJ: 1,
                NY: 3,
                TUSCAN: 3,
                RI: 3
            };
        };

        self.setForecastsDailyTotalsExpand = function (scheduleId, isForecastDailyTotalsExpanded) {
            self.isForecastDailyTotalsExpanded[scheduleId] = isForecastDailyTotalsExpanded;
        };

        self.getForecastedGuideHours = function () {
            return _forecastedGuideHours;
        };

        self.getForecastedLabor = function () {
            return _forecastDetails;
        };

        self.getNonServiceWendysLaborForecast = function () {
            return _nonServiceWendysLaborForecast;
        };

        self.getNonServiceActiveRuleMap = function () {
            return _nonServiceActiveRuleMap;
        }

        self.getGuideHoursRuleMap = function () {
            return _forecastedGuideHoursRuleMap;
        };

        self.getABSSettings = function () {
            return angular.copy(_absSettings);
        };

        self.getBrandScheduleSettings = function () {
            return settings['schedule'];
        };

        self.getIncentiveOpenShiftSettings = () => {
            return incentiveSettingsMap;
        }

        self.getAutomaticIncentiveRulesMap = () => {
            return automaticIncentiveRulesMap;
        }

        self.getRestBetweenDaysRule = function () {
            return settings['schedule'] && settings['schedule']['right_to_rest_compliance_settings'];
        };

        self.getRightToRestSettings = () => {
            return settings?.schedule?.right_to_rest_settings;
        };

        self.checkOvernightShiftsSettings = function (date, forTwoWeeks) {
            var isOvernightShiftSettingsEnabled = false;
            var overnightShiftsSettings = settings['schedule'] && settings['schedule']['overnight_shift'] || [];
            var startOfWeek = moment(date).format("YYYY-MM-DD");

            for (var i in overnightShiftsSettings) {
                if (new Date(startOfWeek).getTime() >= new Date(overnightShiftsSettings[i].start_date).getTime()) {
                    isOvernightShiftSettingsEnabled = overnightShiftsSettings[i].status === "ACTIVE";
                    break;
                }
            }

            if (isOvernightShiftSettingsEnabled && forTwoWeeks) {
                isOvernightShiftSettingsEnabled = false;
                var previousStartOfWeek = moment(date).clone().subtract(1, 'weeks').format("YYYY-MM-DD");

                for (var i in overnightShiftsSettings) {
                    if (new Date(previousStartOfWeek).getTime() >= new Date(overnightShiftsSettings[i].start_date).getTime()) {
                        isOvernightShiftSettingsEnabled = overnightShiftsSettings[i].status === "ACTIVE";
                        break;
                    }
                }
            }

            return isOvernightShiftSettingsEnabled;
        };

        self.setShiftSources = function (sources) {
            shiftsSources = {};
            for (var i in sources) {
                var shiftSource = sources[i];
                var shiftId = sources[i].reference && sources[i].reference['id'];
                shiftsSources[shiftId] = shiftSource.source;
            }
        };

        self.getShiftSources = function (shiftId) {
            if (shiftId) {
                return shiftsSources[shiftId];
            }
            else {
                return shiftsSources;
            }
        };

        self.getBlendedRateActiveStatus = function (date, blendedRatesIntervals) {
            const startDate = moment(date);
            for (const activeInterval of blendedRatesIntervals) {
                if (startDate.isSameOrAfter(activeInterval.start_date) && (!activeInterval.end_date) || startDate.isSameOrBefore(activeInterval.end_date)) {
                    return true;
                }
            }
            return false;
        };

        self.setBlendedRateStatus = function (isBlendedRateEnabled) {
            self.isBlendedRateEnabled = isBlendedRateEnabled;
        };

        self.setUnifiedRolesArray = function (roles) {
            self.unifiedRolesArray = roles;
        }

        self.unifyEmployeeRoles = function (roles, updateBrandRoles, updatedBrandId) {
            var unifiedRolesMap = {};

            if (updateBrandRoles) {
                self.unifiedRolesArray = _.reject(self.unifiedRolesArray, function (role) {
                    return role.brand_id && role.brand_id === updatedBrandId;
                })

                for (var i in roles) {
                    roles[i].brand_id = updatedBrandId;
                }

                roles = roles.concat(self.unifiedRolesArray);
                self.unifiedRolesArray = roles.slice();
            }

            for (var i in roles) {
                var rolePositionCode = roles[i].position.code;
                var brandId = roles[i].brand_id;
                unifiedRolesMap[rolePositionCode] = unifiedRolesMap[rolePositionCode] || {id: roles[i].id, position: roles[i].position, roleDays: {}};

                for (var j in roles[i].role_days) {
                    var day = roles[i].role_days[j];
                    unifiedRolesMap[rolePositionCode].roleDays[day.date] = unifiedRolesMap[rolePositionCode].roleDays[day.date] || {date: day.date, status: day.status, id: day.id, assigneesMap: {}};

                    for (var k in day.assignees) {
                        var dayAssignee = angular.copy(day.assignees[k]);
                        dayAssignee.assignee_shifts = [];
                        day.assignees[k].assignee_shifts.forEach(function (shift) {
                            shift.brand_id = brandId;
                        })
                        unifiedRolesMap[rolePositionCode].roleDays[day.date].assigneesMap[dayAssignee.user_id] = unifiedRolesMap[rolePositionCode].roleDays[day.date].assigneesMap[dayAssignee.user_id] || dayAssignee;
                        unifiedRolesMap[rolePositionCode].roleDays[day.date].assigneesMap[dayAssignee.user_id].assignee_shifts = unifiedRolesMap[rolePositionCode].roleDays[day.date].assigneesMap[dayAssignee.user_id].assignee_shifts.concat(day.assignees[k].assignee_shifts);
                    }

                    unifiedRolesMap[rolePositionCode].roleDays[day.date].assignees = Object.values(unifiedRolesMap[rolePositionCode].roleDays[day.date].assigneesMap);
                }

                unifiedRolesMap[rolePositionCode].role_days = Object.values(unifiedRolesMap[rolePositionCode].roleDays);
            }

            return Object.values(unifiedRolesMap);
        }

        self.parseData = function (scheduleData, settings) {
            settings = $.extend({}, settings) || {};
            var scheduleSettings = self.getBrandScheduleSettings();
            var rawScheduleData = $.extend({}, scheduleData);
            var isOvernightShiftSettingsEnabled = self.checkOvernightShiftsSettings(self.startDate);

            //clear extended shifts
            if (isOvernightShiftSettingsEnabled) {
                self.flatData['extended_shifts'] = {};
                self.flatData['extended_days'] = {};
                self.flatData['extended_user_shifts'] = {};
            }

            for (var i in rawScheduleData.roles) {
                var role = rawScheduleData.roles[i];
                self.flatData['roles'][role.id] = self.flatData['roles'][role.id] || role;
                self.flatData['roles'][role.id]['assignee_ids'] = self.flatData['roles'][role.id]['assignee_ids'] || [];
                self.flatData['roles'][role.id]['user_ids'] = self.flatData['roles'][role.id]['user_ids'] || [];

                self.mappings['position_category'][role.position.code] = role.position.category;

                for (var j in role.role_days) {
                    var roleDay = role.role_days[j];
                    roleDay['role_id'] = role.id;

                    self.flatData['roleDays'][roleDay.id] = self.flatData['roleDays'][roleDay.id] || roleDay;

                    self.mappings['roleday_position'][roleDay.id] = self.flatData['roles'][role.id].position;

                    self.flatData['days'][roleDay.date] = self.flatData['days'][roleDay.date] || { 'id': roleDay.date, 'roleday_ids': [], 'role_ids': [], 'user_ids': [] };
                    var day = self.flatData['days'][roleDay.date];

                    self.mappings['day_role'][day.id + "_" + role.id] = roleDay.id;

                    (day['roleday_ids'].indexOf(roleDay.id) == -1) && day['roleday_ids'].push(roleDay.id);
                    (day['role_ids'].indexOf(role.id) == -1) && day['role_ids'].push(role.id);

                    for (var k in roleDay.assignees) {
                        var assignee = roleDay.assignees[k];
                        assignee.roleday_id = roleDay.id;
                        assignee.role_id = role.id;
                        assignee.status = 'PUBLISHED';

                        self.flatData['users'][assignee.user_id] = self.flatData['users'][assignee.user_id] || { 'id': assignee.user_id, 'assignee_ids': [], 'role_ids': [], 'roleday_ids': [], 'shift_ids': []};
                        var user = self.flatData['users'][assignee.user_id];

                        if (!self.mappings['day_user'][day.id + "_" + user.id]) {
                            self.mappings['day_user'][day.id + "_" + user.id] = [];
                        }

                        self.mappings['user_roleday'][user.id + "_" + roleDay.id] = assignee.id;
                        (self.mappings['day_user'][day.id + "_" + user.id].indexOf(assignee.id) == -1) && self.mappings['day_user'][day.id + "_" + user.id].push(assignee.id);

                        for (var l in assignee.assignee_shifts) {
                            var shift = assignee.assignee_shifts[l];

                            if (shift.status !== 'PUBLISHED') {
                                assignee.status = 'UNPUBLISHED';
                            }

                            if (shift.earliest_published_by) {
                                self.flatData['publishers'][shift.earliest_published_by] = self.flatData['publishers'][shift.earliest_published_by] || {id: shift.earliest_published_by}
                                if (shift.published_by) {
                                    self.flatData['publishers'][shift.published_by] = self.flatData['publishers'][shift.published_by] || {id: shift.published_by}
                                }
                            }

                            shift['role_id'] = role.id;
                            shift['roleday_id'] = roleDay.id;
                            shift['assignee_id'] = assignee.id;
                            shift['user_id'] = user.id;
                            shift['day'] = day.id;
                            shift['brand_id'] = shift['brand_id'] || rawScheduleData['brand_id'] || self.brandId;
                            shift['brand_details'] = teamScheduleService.getBrandById(shift['brand_id']);
                            shift['showBrandDetails'] = settings.employeeMode;
                            shift['cross_location'] = false;
                            shift['breaks'] = shift['breaks'] || [];
                            shift['hideEndDate'] = !assignee.show_shift_end_time && settings.employeeMode;
                            shift['position'] = role.position;
                            shift['schedule_id'] = rawScheduleData.id || self.scheduleId;
                            shift['isPendingEmployeeConsent'] = shift.employee_consent && shift.employee_consent.status === 'PENDING_EMPLOYEE_APPROVAL';

                            if (shift['hideEndDate'] && self.dayCloseHour) {
                                var shiftEndDate = moment(roleDay.date);
                                var endDateEpochMS = shiftEndDate.valueOf() + self.dayCloseHour;

                                shift['end_time'] = moment(endDateEpochMS).format("MMM DD, YYYY HH:mm");
                            }

                            var shiftShiftTime = (
                                shiftTemplateUtils.timeObjToSeconds(shift.start_time).hours +
                                shiftTemplateUtils.timeObjToSeconds(shift.start_time).minutes
                            ) * 1000;

                            if (shiftShiftTime < self.dayOpenHour) {
                                shiftShiftTime += 24 * HOUR;
                            }

                            for (var i in shift['breaks']) {
                                if (shift['breaks'][i].start_time && (shift['breaks'][i].start_time * 1000) < shiftShiftTime) {
                                    shift['breaks'][i].start_time += parseInt((24 * HOUR) / 1000);
                                    shift['breaks'][i].end_time += parseInt((24 * HOUR) / 1000);
                                }
                            }

                            if (employeeLatenessReasons[shift.brand_id] && shift.employee_lateness_reason && shift.employee_lateness_reason.id) {
                                shift.employeeReason = employeeLatenessReasons[shift.brand_id][shift.employee_lateness_reason.id];
                            }

                            self.flatData['shifts'][shift.id] = shift;
                            user['shift_ids'].push(shift.id);

                            if (!scheduleData.id) {
                                // This is a partial updated - not the first parse from original data
                                triggerShiftsChanged();
                            }
                        }

                        if (self.flatData['assignees'][assignee.id]) {
                            self.flatData['assignees'][assignee.id].assignee_shifts = self.flatData['assignees'][assignee.id].assignee_shifts.concat(assignee.assignee_shifts);
                        }
                        else {
                            self.flatData['assignees'][assignee.id] = assignee;
                        }

                        addAssigneeToRoleDay(self.flatData['roleDays'][roleDay.id], assignee);

                        (self.flatData['users'][user.id]['assignee_ids'].indexOf(assignee.id) == -1) && self.flatData['users'][user.id]['assignee_ids'].push(assignee.id);
                        (self.flatData['roles'][role.id]['assignee_ids'].indexOf(assignee.id) == -1) && self.flatData['roles'][role.id]['assignee_ids'].push(assignee.id);
                        (self.flatData['users'][user.id]['roleday_ids'].indexOf(roleDay.id) == -1) && self.flatData['users'][user.id]['roleday_ids'].push(roleDay.id);
                        (self.flatData['users'][user.id]['role_ids'].indexOf(role.id) == -1) && self.flatData['users'][user.id]['role_ids'].push(role.id);
                        (self.flatData['roles'][role.id]['user_ids'].indexOf(user.id) == -1) && self.flatData['roles'][role.id]['user_ids'].push(user.id);
                        (day['user_ids'].indexOf(user.id) == -1) && day['user_ids'].push(user.id);
                    }

                    addRoleDayToRole(self.flatData['roles'][role.id], self.flatData['roleDays'][roleDay.id]);
                }
            }

            self.setSelectedScheduleRoles();
            self.updateParLaborData();

            if (isOvernightShiftSettingsEnabled) {
                var extendedData = calculateScheduleExtendedShifts(self.flatData['roleDays'] || {});
                self.flatData['extended_shifts'] = extendedData['extended_shifts'];
                self.flatData['extended_days'] = extendedData['extended_days'];
                self.flatData['extended_user_shifts'] = extendedData['extended_user_shifts'];
            }
            if (scheduleSettings && scheduleSettings['max_scheduled_days'] && scheduleSettings['max_scheduled_days']['schedule_max_working_days_week_type'] !== 'NONE') {
                prepareUserShiftsForWorkingDays(scheduleSettings['max_scheduled_days']['schedule_max_working_days_week_type']);
            }
        };

        self.parseExtraScheduleDayData = function (extraDayData) {
            self.extraDayFlatData['shifts'] = {};
            self.extraDayFlatData['users'] = {};
            self.extraDayFlatData['roleDays'] = {};
            self.extraDayFlatData['extended_shifts'] = {};
            self.extraDayFlatData['extended_days'] = {};
            self.extraDayFlatData['extended_user_shifts'] = {};

            for (var s in extraDayData) {
                var extraScheduleDayRoles = extraDayData[s].roles;

                for (var i in extraScheduleDayRoles) {
                    var extraScheduleDayRole = extraScheduleDayRoles[i];

                    for (var j in extraScheduleDayRole.role_days) {
                        var extraRoleDays = extraScheduleDayRole.role_days[j];
                        self.extraDayFlatData['roleDays'][extraRoleDays.id] = extraRoleDays;

                        for (var k in extraRoleDays.assignees) {
                            var assignee = extraRoleDays.assignees[k];

                            for (var l in assignee.assignee_shifts) {
                                var shift = assignee.assignee_shifts[l];
                                shift['user_id'] = assignee.user_id;
                                shift['brand_id'] = extraDayData[s]['brand_id'] || self.brandId;
                                shift['day'] = extraRoleDays.date;
                                shift['role_id'] = extraScheduleDayRole.id;
                                shift['roleday_id'] = extraRoleDays.id;
                                shift['assignee_id'] = assignee.id;
                                shift['position'] = extraScheduleDayRole.position;

                                self.extraDayFlatData['shifts'][shift.id] = shift;
                                self.extraDayFlatData['users'][assignee.user_id] = self.extraDayFlatData['users'][assignee.user_id] || { 'id': assignee.user_id, 'shift_ids': []};
                                self.extraDayFlatData['users'][assignee.user_id]['shift_ids'].push(shift.id);
                            }
                        }
                    }
                }
            }

            if (self.checkOvernightShiftsSettings(self.startDate, true)) {
                var extendedData = calculateScheduleExtendedShifts(self.extraDayFlatData['roleDays'] || {}, true);
                self.extraDayFlatData['extended_shifts'] = extendedData['extended_shifts'];
                self.extraDayFlatData['extended_days'] = extendedData['extended_days'];
                self.extraDayFlatData['extended_user_shifts'] = extendedData['extended_user_shifts'];
            }
        };

        self.parseExtraCrossScheduleDayData = function (extraCrossDayData) {
            self.usersCrossLocationShiftsWeekBefore = {};
            self.extraCrossDayFlatData = {};
            self.extraCrossDayFlatData['shifts'] = {};
            self.extraCrossDayFlatData['brands'] = {};

            for (var cs in extraCrossDayData) {
                var rawScheduleData = $.extend({}, extraCrossDayData[cs]);

                self.extraCrossDayFlatData['brands'][rawScheduleData['brand_id']] = {
                    roleDays: {},
                    extended_shifts: {},
                    extended_days: {}
                };

                for (var i in rawScheduleData.roles) {
                    var role = rawScheduleData.roles[i];

                    for (var j in role.role_days) {
                        var roleDay = role.role_days[j];
                        self.extraCrossDayFlatData['brands'][rawScheduleData['brand_id']]['roleDays'][roleDay.id] = roleDay;

                        for (var k in roleDay.assignees) {
                            var assignee = roleDay.assignees[k];

                            for (var l in assignee.assignee_shifts) {
                                var shift = assignee.assignee_shifts[l];
                                shift['user_id'] = assignee.user_id;
                                shift['day'] = roleDay.date;
                                shift['brand_id'] = rawScheduleData['brand_id'];
                                shift['role_id'] = role.id;
                                shift['roleday_id'] = roleDay.id;
                                shift['assignee_id'] = assignee.id;
                                shift['position'] = role.position;
                                shift['cross_location'] = true;
                                shift.faded = self.highlightedShiftsIds.length && self.highlightedShiftsIds.indexOf(shift.id) === -1;

                                self.extraCrossDayFlatData['shifts'][shift.id] = shift;
                            }
                        }
                    }
                }
            }

            if (self.checkOvernightShiftsSettings(self.startDate, true)) {
                for (var brandId in self.extraCrossDayFlatData['brands']) {
                    var brandCrossFlatData = self.extraCrossDayFlatData['brands'][brandId];
                    var extendedData = calculateScheduleExtendedShifts(brandCrossFlatData['roleDays'] || {}, true, true);
                    brandCrossFlatData['extended_shifts'] = extendedData['extended_shifts'];
                    brandCrossFlatData['extended_days'] = extendedData['extended_days'];

                    for (var s in brandCrossFlatData['extended_shifts']) {
                        var shift = brandCrossFlatData['extended_shifts'][s];
                        shift.isFromWeekBefore = true;
                        self.usersCrossLocationShiftsWeekBefore[shift.user_id] = self.usersCrossLocationShiftsWeekBefore[shift.user_id] || [];
                        self.usersCrossLocationShiftsWeekBefore[shift.user_id].push(shift);
                        shift.faded = self.highlightedShiftsIds.length && self.highlightedShiftsIds.indexOf(shift.id) === -1;
                    }
                }
            }
        };

        var setDayAsMarkedDay = function (closedDay) {
            const startDate = Utils.getWeekStart(moment(self.activeScheduleDay), self.getBrandStartDayOfWeek()).format("YYYY-MM-DD");

            for (var i = 0; i < 7; i++) {
                var weekDay = moment(startDate).clone().add(i, 'days');
                var day = weekDay.format('ddd').toUpperCase();
                if (day === closedDay) {
                    var formattedClosedDay = moment(weekDay).format('MMM DD, YYYY');
                    var businessDayStartTime = moment(formattedClosedDay).valueOf() + self.dayOpenHour;
                    var businessDayEndTime = moment(formattedClosedDay).valueOf() + self.dayCloseHour;

                    self.markedDays[formattedClosedDay] = self.markedDays[formattedClosedDay] || {intervals: []};
                    self.markedDays[formattedClosedDay].intervals.push({
                        from: moment(businessDayStartTime).format(TIME_FORMAT),
                        to: moment(businessDayEndTime).format(TIME_FORMAT),
                        reason: {
                            code: 'CLOSED_DAY',
                            name: _filter('translate')('Closed')
                        },
                    });
                    self.markedDays[formattedClosedDay].isMarkedAsHighlighted = true;
                    break;
                }
            }
        };

        self.markScheduleDays = function () {
            self.markedDays = {};
            if (self.brandHolidays) {
                for (var date in self.brandHolidays) {
                    var holidayTypes = self.brandHolidays[date];
                    for (var j in holidayTypes) {
                        var holiday = holidayTypes[j];
                        var previousDay = moment(date).subtract(1, 'day').format('MMM DD, YYYY');
                        var nextDay = moment(date).add(1, 'day').format('MMM DD, YYYY');
                        self.markedDays[date] = self.markedDays[date] || {intervals: []};
                        self.markedDays[previousDay] = self.markedDays[previousDay] || {intervals: []};

                        var businessDayStartTime = moment(date).valueOf() + self.dayOpenHour;

                        self.markedDays[previousDay].intervals.push({
                            from: moment(date + ' ' + "12:00 AM").format(TIME_FORMAT),
                            to: moment(businessDayStartTime).format(TIME_FORMAT),
                            reason: {code: holiday.type, name: holiday.reason}
                        });
                        self.markedDays[date].intervals.push({
                            from: moment(businessDayStartTime).format(TIME_FORMAT),
                            to: moment(nextDay + ' ' + "12:00 AM").format(TIME_FORMAT),
                            reason: {code: holiday.type, name: holiday.reason}
                        });
                        self.markedDays[date].isMarkedAsHighlighted = true;
                    }
                }
            }

            if (self.operatingHours) {
                if (self.operatingHours['closed_days']) {
                    for (var j in self.operatingHours['closed_days']) {
                        var closedDay = self.operatingHours['closed_days'][j];
                        setDayAsMarkedDay(closedDay);
                    }
                }
                if (self.operatingHours['closed_dates'] && self.operatingHours['closed_dates'].length) {
                    for (const closedDates of (self.operatingHours.closed_dates ?? [])) {
                        let startDate = moment(closedDates.start_date);
                        let endDate = moment(closedDates.end_date);
                        const adjustedEndDate = moment(self.startDate).add(6, 'days');
                        let currentDay = startDate.isBefore(moment(self.startDate)) ? moment(self.startDate).clone() : startDate.clone();

                        if (endDate.isAfter(adjustedEndDate)) {
                            endDate = adjustedEndDate;
                        }

                        while (currentDay.isSameOrBefore(endDate)) {
                            let formattedClosedDate = currentDay.format('MMM DD, YYYY');
                            if (self.markedDays[formattedClosedDate]?.intervals?.length) {
                                let found = self.markedDays[formattedClosedDate].intervals.find((interval) => {
                                    return interval.reason.code === closedReason.CLOSED_DAY;
                                });
                                if (found) {
                                    currentDay.add(1, 'day');
                                    continue;
                                }
                            }
                            const intervals = closedDates.intervals;
                            const businessDayStartTime = currentDay.valueOf() + self.dayOpenHour;
                            const businessDayEndTime = currentDay.valueOf() + self.dayCloseHour;
                            self.markedDays[formattedClosedDate] = self.markedDays[formattedClosedDate] ??= {intervals: []};
                            self.markedDays[formattedClosedDate].isMarkedAsHighlighted = true;
                            if (intervals.length) {
                                for (let interval of intervals) {
                                    let startTime = moment(`${currentDay.format('YYYY-MM-DD')} ${interval.start_time}`);
                                    let endTime = moment(`${currentDay.format('YYYY-MM-DD')} ${interval.end_time}`);

                                    if (moment(businessDayStartTime).isAfter(startTime)) {
                                        startTime.add(1, 'day');
                                    }
                                    if (startTime.isAfter(endTime)) {
                                        endTime.add(1, 'day');
                                    }
                                    self.markedDays[formattedClosedDate].intervals.push({
                                        from: startTime.format(TIME_FORMAT),
                                        to: endTime.format(TIME_FORMAT),
                                        reason: {
                                            code: closedReason.PARTIAL_CLOSED_DATE,
                                            name: _filter('translate')('Partially closed')
                                        }
                                    });
                                }
                            } else {
                                self.markedDays[formattedClosedDate].intervals.push({
                                    from: moment(businessDayStartTime).format(TIME_FORMAT),
                                    to: moment(businessDayEndTime).format(TIME_FORMAT),
                                    reason: {
                                        code: closedReason.CLOSED_DATE,
                                        name: _filter('translate')('Closed')
                                    },
                                });
                            }
                            currentDay.add(1, 'day');
                        }
                    }
                }
            }

            if (self.carrolClosedDays) {
                if (self.carrolClosedDays['closed_days']) {
                    for (var j in self.carrolClosedDays['closed_days']) {
                        var closedDay = self.carrolClosedDays['closed_days'][j];
                        setDayAsMarkedDay(closedDay);
                    }
                }
                if (self.carrolClosedDays['closed_dates'] && self.carrolClosedDays['closed_dates'].length) {
                    for (var j in self.carrolClosedDays['closed_dates']) {
                        var closedDate = self.carrolClosedDays['closed_dates'][j];
                        var formattedClosedDate = moment(closedDate).format('MMM DD, YYYY');
                        if (self.markedDays[formattedClosedDate] && self.markedDays[formattedClosedDate].intervals && self.markedDays[formattedClosedDate].intervals.length) {
                            let found = self.markedDays[formattedClosedDate].intervals.find(function (interval) {
                                return interval.reason.code === 'CLOSED_DAY';
                            });
                            if (found) {
                                continue;
                            }
                        }
                        var businessDayStartTime = moment(closedDate).valueOf() + self.dayOpenHour;
                        var businessDayEndTime = moment(closedDate).valueOf() + self.dayCloseHour;
                        self.markedDays[formattedClosedDate] = self.markedDays[formattedClosedDate] || {intervals: []};
                        self.markedDays[formattedClosedDate].isMarkedAsHighlighted = true;

                        var interval = {
                            from: moment(businessDayStartTime).format(TIME_FORMAT),
                            to: moment(businessDayEndTime).format(TIME_FORMAT),
                            reason: {
                                code: 'CLOSED_DATE',
                                name: _filter('translate')('Closed')
                            },
                        };
                        self.markedDays[formattedClosedDate].intervals.push(interval);
                    }
                }
            }

            if (specialEvents?.length) {
                const markSpecialEvent = (categoryCode, date, start, end) => {
                    self.markedDays[date] = self.markedDays[date] || {intervals: []};
                    self.markedDays[date].isMarkedAsHighlighted = true;

                    const interval = {
                        from: moment(start).format(TIME_FORMAT),
                        to: moment(end).format(TIME_FORMAT),
                        reason: {
                            code: 'SPECIAL_EVENT',
                            name: _specialEventsService.specialEventsCategoriesMap[categoryCode].name
                        }
                    };

                    self.markedDays[date].intervals.push(interval);
                };

                specialEvents.forEach(event => {
                    event.days.forEach(dayPeriod => {

                        const periodDay = self.getShiftDay({start_time: dayPeriod.start_datetime});
                        const businessDayEndTime = moment(periodDay).valueOf() + self.dayCloseHour;

                        if (moment(dayPeriod.end_datetime).valueOf() > businessDayEndTime) {
                            const nextBusinessDay = moment(periodDay).add(1, 'day').format("MMM DD, YYYY");
                            markSpecialEvent(event.category_code, periodDay, dayPeriod.start_datetime, businessDayEndTime)
                            markSpecialEvent(event.category_code, nextBusinessDay, businessDayEndTime, dayPeriod.end_datetime)
                        } else {
                            markSpecialEvent(event.category_code, periodDay, dayPeriod.start_datetime, dayPeriod.end_datetime)
                        }
                    });
                });
            }
        };

        var findEnabledPhSetting = function (settings, startOfWeek) {
            var matchedSettings = {};
            for (var i = settings.length - 1; i >= 0; i--) {
                var setting = settings[i];
                if (startOfWeek.isSameOrAfter(moment(setting.start_date))) {
                    matchedSettings = setting;
                    break;
                }
            }

            if (matchedSettings && matchedSettings.status === 'ENABLED') {
                return matchedSettings;
            }
             return null;
        };

        self.setPhilippinesOverTimeSettings = function (costData, selectedDay) {
            philippinesPremiums = {};
            var startOfWeek = moment(selectedDay);

            if (costData.rest_day_pay && costData.rest_day_pay.length) {
                var restDayPay = findEnabledPhSetting(costData.rest_day_pay, startOfWeek);
                if (restDayPay) {
                    philippinesPremiums['REST_DAY'] = restDayPay;
                }
            }

            var absenceOverTime = costData.absence_overtime || {};

            if (
                (absenceOverTime.regular_holiday && absenceOverTime.regular_holiday.length)  ||
                (absenceOverTime.special_day && absenceOverTime.special_day.length)
              ) {
                var regularHolidaysSettings = prepareEnabledSettingsForWeek(absenceOverTime.regular_holiday, startOfWeek);
                if (regularHolidaysSettings) {
                    philippinesPremiums['REGULAR_HOLIDAY'] = regularHolidaysSettings;
                }
                var specialNonWorkingDaySettings = prepareEnabledSettingsForWeek(absenceOverTime.special_day, startOfWeek);
                if (specialNonWorkingDaySettings) {
                    philippinesPremiums['SPECIAL_NON_WORKING_DAY'] = prepareEnabledSettingsForWeek(absenceOverTime.special_day, startOfWeek)
                }
            }
        };


        var prepareEnabledSettingsForWeek = function (settings, startOfWeek) {
            var enabledSettingsPerDay;

            for (var i = 0; i < 7; i++) {
                var weekDay = startOfWeek.clone().add(i, "days");
                var holiday = findEnabledPhSetting(settings, weekDay);
                if (holiday) {
                    enabledSettingsPerDay = enabledSettingsPerDay || {days: {}}
                    var formattedStartDate = moment(weekDay).format('MMM DD, YYYY');
                    enabledSettingsPerDay['days'][formattedStartDate] = true;
                }
            }
            return enabledSettingsPerDay;
        }

        self.getPhilippinesOverTimeSettings = function () {
            return philippinesPremiums;
        }

        self.getHolidaysNamesPerDay = function (day) {
            var holidaysPerDay = {};
            for (var weekDay in self.markedDays) {
                var reasons = {};
                var intervals = self.markedDays[weekDay].intervals;
                var date = moment(weekDay).format('YYYY-MM-DD');
                holidaysPerDay[date] = [];
                for (var interval of intervals) {
                    reasons[interval.reason.code] = interval.reason.name
                }
                holidaysPerDay[date] = Object.values(reasons);
            }

            if (day) {
                var selectedDay = day.format('YYYY-MM-DD');
                return holidaysPerDay[selectedDay];
            }
            return holidaysPerDay;
        }

        self.setMarkedAsOffDays = function (markedAsOffDays) {
            self.markedOffDays = {};

            for (var i in markedAsOffDays) {
                self.markedOffDays[markedAsOffDays[i].id] = markedAsOffDays[i]['schedule_user_day_markers'];
            }
        }

        self.addUserMarkedDay = function (userId, markedDaySlot) {
            self.markedOffDays[userId] = self.markedOffDays[userId] || [];
            self.markedOffDays[userId].push(markedDaySlot);
        }

        self.hasMarkedDayIncludedPosition = function (userPositions) {
            var markedDaySettings = settings['schedule']['schedule_user_day_markers'];
            var includedPositionCodes = _.pluck(markedDaySettings.positions, 'code');
            var canMarkDay = false;

            for (var i in userPositions) {
                canMarkDay = canMarkDay || (includedPositionCodes.indexOf(userPositions[i].code) > -1);
                if (canMarkDay) {
                    break;
                }
            }

            return canMarkDay;
        }

        self.getMarkedDayReasons = (day) => {

            const date = moment(day).format('MMM DD, YYYY')
            const lastYearDate = moment(day).subtract(1, 'y').format('MMM DD, YYYY')

            const reasons = {};
            if (self.markedDays[date]?.intervals?.length) {
                for (const interval of self.markedDays[date].intervals) {
                    reasons[interval.reason.code] = reasons[interval.reason.code] || {notes: []};
                    if (interval.reason.code === 'SPECIAL_EVENT') {
                        if (self.markedDays[lastYearDate]?.intervals?.length > 0) {
                            reasons[interval.reason.code].name = _filter('translate')('Current year');
                        }
                        reasons[interval.reason.code].notes.push(interval.reason.name);
                        reasons[interval.reason.code].notes = reasons[interval.reason.code].notes.filter((value, index, array) => array.indexOf(value) === index);
                    }
                    else {
                        reasons[interval.reason.code].name = interval.reason.name;
                        if (interval.reason.code === 'PARTIAL_CLOSED_DATE') {
                            reasons[interval.reason.code].notes.push(moment(interval.from).format('h:mm a') + ' - ' + moment(interval.to).format('h:mm a'));
                        }
                    }
                }
            }

            if (self.markedDays[lastYearDate]?.intervals?.length) {
                for (const interval of self.markedDays[lastYearDate].intervals) {
                    reasons[`LAST_YEAR_${interval.reason.code}`] = reasons[`LAST_YEAR_${interval.reason.code}`] || {notes: []};
                    if (interval.reason.code === 'SPECIAL_EVENT') {
                        reasons[`LAST_YEAR_${interval.reason.code}`].name = _filter('translate')('Last year');
                        reasons[`LAST_YEAR_${interval.reason.code}`].notes.push(interval.reason.name);
                        reasons[`LAST_YEAR_${interval.reason.code}`].notes = reasons[`LAST_YEAR_${interval.reason.code}`].notes.filter((value, index, array) => array.indexOf(value) === index);
                    }
                }
            }

            return Object.values(reasons)
        };

        self.parseClosedDaysData = function (operatingHours, carrolClosedDays) {
            self.operatingHours = operatingHours;
            self.carrolClosedDays = carrolClosedDays;
        };

        self.isMarkedDay = function (date) {
            var day = date.format('MMM DD, YYYY');
            if (self.markedDays && self.markedDays[day]) {
                var weekDay = self.markedDays[day];
                if (weekDay.isMarkedAsHighlighted) {
                    return true;
                }
            }
            return false;
        };

        self.isClosedDay = function (date) {
            var day = date.format('MMM DD, YYYY');
            if (self.markedDays && self.markedDays[day]?.intervals?.length) {
                return (self.markedDays[day].intervals.find((interval) => {
                    return interval.reason.code !== 'SPECIAL_EVENT';
                }));
            }
        };

        self.getScheduleUnPublishedFlatData = function () {
            var defer = $q.defer();
            defer.resolve(angular.copy(self.flatData['shifts']));
            return defer.promise;
        };

        self.getExtendedShiftsForDay = function (selectedDay) {
            var extendedShiftsForDay = [];

            if (selectedDay) {
                if (self.flatData['extended_days'] && self.flatData['extended_days'][selectedDay]) {
                    extendedShiftsForDay = self.flatData['extended_days'][selectedDay]['shifts'];
                } else if (self.extraDayFlatData['extended_days'] && self.extraDayFlatData['extended_days'][selectedDay]) {
                    extendedShiftsForDay = self.extraDayFlatData['extended_days'][selectedDay]['shifts'];
                }
            } else {
                var extendedShifts = self.flatData['extended_shifts'] && Object.values(self.flatData['extended_shifts']) || [];
                var beforeDayExtendedShifts = self.extraDayFlatData['extended_shifts'] && Object.values(self.extraDayFlatData['extended_shifts']) || [];
                extendedShiftsForDay = extendedShifts.concat(beforeDayExtendedShifts);
            }

            return extendedShiftsForDay;
        };

        self.getExtendedShiftsFromWeekBefore = function (schedule, rowId) {
            var extendedShiftsForDay = [];

            if (self.extraDayFlatData['extended_shifts'] && Object.keys(self.extraDayFlatData['extended_shifts']).length) {
                switch (schedule.type) {
                    case 'role':
                        extendedShiftsForDay = _.filter(self.extraDayFlatData['extended_shifts'], function (shift) {
                            var shiftPosition = shift['position'];

                            return (shiftPosition.code === schedule.key && shift['user_id'] === rowId);
                        });
                        break;
                    case 'category':
                        extendedShiftsForDay = _.filter(self.extraDayFlatData['extended_shifts'], function (shift) {
                            var shiftCategory = shift['position']['category'];

                            return (shiftCategory.code === schedule.id && shift['user_id'] === rowId);
                        });
                        break;
                    case 'positions':
                        if (rowId) {
                            extendedShiftsForDay = _.filter(self.extraDayFlatData['extended_shifts'], function (shift) {
                                return shift['role_id'] === rowId;
                            });
                        } else {
                            extendedShiftsForDay = self.extraDayFlatData['extended_shifts'];
                        }

                        break;
                    default:
                        extendedShiftsForDay = _.filter(self.extraDayFlatData['extended_shifts'], function (shift) {
                            return shift['user_id'] === rowId;
                        });
                }
            }

            return extendedShiftsForDay;
        };

        self.getExtendedShiftsForWeek = function (schedule, rowId) {
            var extendedShiftsForWeek = [];

            if (self.flatData['extended_shifts'] && Object.keys(self.flatData['extended_shifts']).length) {
                switch (schedule.type) {
                    case 'role':
                        extendedShiftsForWeek = _.filter(self.flatData['extended_shifts'], function (shift) {
                            var shiftPosition = shift['position'];

                            return (shiftPosition.code === schedule.key && shift['user_id'] === rowId);
                        });
                        break;
                    case 'category':
                        extendedShiftsForWeek = _.filter(self.flatData['extended_shifts'], function (shift) {
                            var shiftCategory = shift['position']['category'];

                            return (shiftCategory.code === schedule.id && shift['user_id'] === rowId);
                        });
                        break;
                    case 'positions':
                        if (rowId) {
                            extendedShiftsForWeek = _.filter(self.flatData['extended_shifts'], function (shift) {
                                return shift['role_id'] === rowId;
                            });
                        } else {
                            extendedShiftsForWeek = self.flatData['extended_shifts'];
                        }

                        break;
                    default:
                        extendedShiftsForWeek = _.filter(self.flatData['extended_shifts'], function (shift) {
                            return shift['user_id'] === rowId;
                        });
                }
            }

            return extendedShiftsForWeek;
        };

        var calculateScheduleExtendedShifts = function (roleDays, fromPreviousWeek, crossLocation) {
            var extendedData = {
                extended_shifts: {},
                extended_days: {},
                extended_user_shifts: {}
            };

            var lastWeekDate = moment(self.startDate).clone().add(6, 'days').format('MMM DD, YYYY');

            for (var i in roleDays) {
                var roleDay = roleDays[i];
                var nextDay = moment(roleDay['date']).clone().add(1, 'days').format('MMM DD, YYYY');

                for (var j in roleDay.assignees) {
                    var assignee = roleDay.assignees[j];

                    for (var k in assignee.assignee_shifts) {
                        var shift = assignee.assignee_shifts[k];
                        shift['isExtendedOverNextDay'] = false;
                        var shiftTimeObject = shiftTemplateUtils.getIntervalTime(self.dayOpenHour, {start_time: shift['start_time'], end_time: shift['end_time']});

                        if (shiftTimeObject['end_time'] > self.dayCloseHour) {
                            var extendedShift = angular.copy(shift);
                            extendedShift['isExtendedFromPreviousDay'] = true;
                            extendedShift['extendedDay'] = nextDay;

                            var addShift = true;

                            if (fromPreviousWeek) {
                                var scheduleRole;

                                if (crossLocation) {
                                    var crossLocationRoles = self.crossFlatData[extendedShift.brand_id] && self.crossFlatData[extendedShift.brand_id]['roles'] || {};

                                    scheduleRole = _.find(crossLocationRoles, function (role) {
                                        return role.position.code === extendedShift.position.code;
                                    });

                                    if (!scheduleRole) {
                                        scheduleRole = _.find(self.scheduleRoles, function (role) {
                                            return role.position.code === extendedShift.position.code;
                                        });
                                    }
                                } else {
                                    scheduleRole = _.find(self.scheduleRoles, function (role) {
                                        return role.position.code === extendedShift.position.code;
                                    });
                                }

                                if (scheduleRole && scheduleRole.id) {
                                    extendedShift['role_id'] = scheduleRole.id;
                                    extendedShift['isExtendedFromPreviousWeek'] = true;
                                } else {
                                    addShift = false;
                                }
                            }

                            if (addShift && shift['day'] !== lastWeekDate) {
                                extendedData['extended_shifts'][extendedShift['id']] = extendedShift;
                                extendedData['extended_days'][nextDay] = extendedData['extended_days'][nextDay] || {shifts: []};
                                extendedData['extended_days'][nextDay]['shifts'].push(extendedShift);
                                extendedData['extended_user_shifts'][extendedShift.user_id] = extendedData['extended_user_shifts'][extendedShift.user_id] || {shifts: []};
                                extendedData['extended_user_shifts'][extendedShift.user_id]['shifts'].push(extendedShift);
                            }

                            if (shift['day'] === lastWeekDate) {
                                shift['isExtendedOverNextWeek'] = true;
                            }

                            shift['isExtendedOverNextDay'] = true;
                        }
                    }
                }
            }

            return extendedData;
        };

        self.isShiftExtendedOverNextDay = function (shift) {
            var shiftTimeObject = shiftTemplateUtils.getIntervalTime(self.dayOpenHour, {start_time: shift['start_time'], end_time: shift['end_time']});

            if (shiftTimeObject['end_time'] > self.dayCloseHour) {
                return true;
            }
            return false;
        }

        self.haveViewData = function (selectedDay) {
            return (
                self.flatData['days'][selectedDay] ||
                (self.flatData['extended_days'] && self.flatData['extended_days'][selectedDay]) ||
                (self.extraDayFlatData['extended_days'] && self.extraDayFlatData['extended_days'][selectedDay])
            );
        };

        self.getCrossLocationsUsersData = function () {
            var isOvernightShiftSettingsEnabled = self.checkOvernightShiftsSettings(self.startDate, true);

            if (isOvernightShiftSettingsEnabled) {
                var crossLocationsUsers = {};

                for (var userId in self.usersCrossLocationShifts) {
                    crossLocationsUsers[userId] = crossLocationsUsers[userId] || [];
                    crossLocationsUsers[userId] = crossLocationsUsers[userId].concat(self.usersCrossLocationShifts[userId] || []);
                }

                for (var userId in self.usersCrossLocationShiftsWeekBefore) {
                    crossLocationsUsers[userId] = crossLocationsUsers[userId] || [];
                    crossLocationsUsers[userId] = crossLocationsUsers[userId].concat(self.usersCrossLocationShiftsWeekBefore[userId] || []);
                }

                return crossLocationsUsers;
            } else {
                return self.usersCrossLocationShifts
            }
        };

        self.getScheduleUsersByDay = function (day) {
            var users;

            if (day) {
                users = self.flatData['days'] && self.flatData['days'][day] && self.flatData['days'][day]['user_ids'] || [];
            } else {
                users = Object.keys(self.flatData['users'] || []);
            }

            return angular.copy(users);
        };

        self.setFairSchedulingSettings = function (isFairSchedulingEnabled) {
            isFairSchedulingServiceEnabled = isFairSchedulingEnabled;
        };

        self.setJustCauseServiceEnabled = function (isJustCauseEnabled) {
            isJustCauseServiceEnabled = isJustCauseEnabled;
        };

        self.getJustCauseServiceEnabled = function () {
            return isJustCauseServiceEnabled;
        };

        self.setBrandScheduleSettings = function (scheduleSettings) {
            settings['schedule'] = scheduleSettings;
        };

        self.setIncentiveOpenShiftSettings = (incentiveSettings) => {
            incentiveSettingsMap = incentiveSettings;
        }

        self.setAutomaticIncentiveRulesMap = (automaticRulesMap) => {
            automaticIncentiveRulesMap = automaticRulesMap;
        }

        self.setIsMarkedDaysEnabled = function (isMarkedDaysEnabled) {
            isMarkedDaysServiceEnabled = isMarkedDaysEnabled;
        }

        self.getIsMarkedDaysEnabled = function () {
            return isMarkedDaysServiceEnabled;
        }

        self.getIsWorkingPatternEnabled = () => {
            return isWorkingPatternsServiceEnabled;
        }

        self.setIsWorkingPatternEnabled = (isWorkingPatternEnabled) => {
            isWorkingPatternsServiceEnabled = isWorkingPatternEnabled;
        }

        self.setUserPositionsPreferencesSettings = function (positionsPreferencesSettings) {
            userPositionsPreferences = positionsPreferencesSettings || [];
        };

        self.getUserPositionsPreferencesSettings = function () {
            return userPositionsPreferences;
        };

        self.getUserPositionsPreferencesCodes = function () {
            var userPositionsPreferencesCodes = [];

            for (var i in userPositionsPreferences) {
                var position = userPositionsPreferences[i]['position'];

                userPositionsPreferencesCodes.push(position['code']);
            }

            return userPositionsPreferencesCodes;
        };

        self.checkAutoAssignCustomOptions = function (brandId) {
            //test brands:
            return [610177, 610162, 709249, 1204845, 5335219, 5490106, 610150, 610151, 610153, 610154, 610155, 5603819, 5699449, 5727353, 6225824].indexOf(brandId) > -1;
        };

        // prod brands: 709249, 610150, 610154
        // uat brands: 709249
        // dev brands: 11288040, 10117966, 545128
        /**
         * changing the custom options for auto assign.
         * @param brandId
         * @returns {boolean}
         */
        self.checkConsiderPositionWhileAssigning = (brandId) => (
            [
                709249, 610150, 610154,
                11288040, 10117966, 545128
            ].includes(brandId)
        );

        self.sortByUserPositionsPreferences = function (items) {
            var userPositionsPreferencesCodes = self.getUserPositionsPreferencesCodes();
            items.forEach(function (item) {
                var user_position_preference_sort = userPositionsPreferencesCodes.length;
                var indexOfPreferencePosition = userPositionsPreferencesCodes.indexOf(item.position.code);
                if (indexOfPreferencePosition > -1) {
                    user_position_preference_sort = indexOfPreferencePosition;
                }
                item.user_position_preference_sort = user_position_preference_sort;
            });
            return _.sortBy(items, 'user_position_preference_sort');
        };

        self.checkShiftExtendedToNextBusinessDay = function (shift, day) {
            return brandBusinessDayUtils.isInBusinessDayExtension({
                start_time: shift.start_time,
                end_time: shift.end_time
            }, day);
        };

        self.setHighlightedWarningShifts = function (shiftIds) {
            self.highlightedShiftsIds = shiftIds;
        };

        self.getEffectiveNewHiresSettingsThreshold = function (newHiresSettingsList, date) {
            var threshold = 0;

            for (var i in newHiresSettingsList) {
                var settingItem = newHiresSettingsList[i];
                if (_scheduleDateUtilsService.moment(date).isSameOrAfter(_scheduleDateUtilsService.moment(settingItem.start_date))) {
                    threshold = settingItem.threshold;
                    break;
                }
            }

            return parseInt(threshold / 24 / 3600);
        };

        self.isNewlyHied = function (date, userId, forWeek) {
            if (isFairSchedulingServiceEnabled) {
                var newHiresSettings = settings['schedule']['fair_work_week_settings'] && settings['schedule']['fair_work_week_settings']['new_hire_penalty_grace_period_settings'] || [];
                var selectedDate = _scheduleDateUtilsService.moment(date);

                var weekEnd = selectedDate.clone().add(6, 'days');

                if (userId && !isNaN(userId)) {
                    var userDetails = _TSUsersService.users[userId];

                    if (userDetails.hire_date) {
                        var newHiresThreshold = self.getEffectiveNewHiresSettingsThreshold(newHiresSettings, userDetails.hire_date);
                        var hireDate = _scheduleDateUtilsService.moment(userDetails.hire_date);
                        var newlyHireMaxDate = hireDate.clone().add(newHiresThreshold, 'days');

                        if (newHiresThreshold > 0) {
                            if (
                                forWeek &&
                                (
                                    (hireDate.isSameOrAfter(selectedDate) && hireDate.isSameOrBefore(weekEnd)) ||
                                    (selectedDate.isSameOrBefore(hireDate) || newlyHireMaxDate.isAfter(selectedDate))
                                )
                            ) {
                                return true;
                            }

                            if (
                                !forWeek &&
                                selectedDate.isSameOrAfter(hireDate) &&
                                selectedDate.isBefore(newlyHireMaxDate)
                            ) {
                                return true;
                            }
                        }
                    }
                }
            }

            return false;
        };

        self.prepareScheduleFiltersItems = function (users, viewPreset) {
            var scheduleFiltersItems = {
                categories: {},
                positions: {},
                categoriesArr: [],
                positionsArr: [],
                publishingCategories: [],
            };

            scheduleFiltersItems.users = filterPresetEmployees(viewPreset, users);

            for (var i in scheduleFiltersItems.users) {
                scheduleFiltersItems.users[i].name = [scheduleFiltersItems.users[i].first_name, scheduleFiltersItems.users[i].last_name].join(" ");

                if (scheduleFiltersItems.users[i].positions) {
                    for (var j in scheduleFiltersItems.users[i].positions) {
                        var position = scheduleFiltersItems.users[i].positions[j];
                        var includePosition = true;

                        if (!scheduleFiltersItems.positions[position.code]) {
                            if (viewPreset && viewPreset.id !== 'MAIN') {
                                var positionIndex = viewPreset.positions.findIndex(function (item) {
                                    return position.code === item.code;
                                });

                                includePosition = positionIndex > -1;

                                if (includePosition) {
                                    scheduleFiltersItems.positions[position.code] = position;
                                    scheduleFiltersItems.positionsArr.push(position);
                                }
                            } else {
                                scheduleFiltersItems.positions[position.code] = position;
                                scheduleFiltersItems.positionsArr.push(position);
                            }
                        }

                        if (!scheduleFiltersItems.categories[position.category['code']] && includePosition) {
                            scheduleFiltersItems.categories[position.category['code']] = position.category;
                            scheduleFiltersItems.categoriesArr.push(position.category);
                        }
                    }
                }
            }

            scheduleFiltersItems.publishingCategories = _.reject(scheduleFiltersItems.categories, function (item, key) {
                return key === 'ALL';
            });
            scheduleFiltersItems.users = _.sortBy(scheduleFiltersItems.users, "first_name");

            return scheduleFiltersItems;
        };



        var filterPresetEmployees = function (schedulePreset, users) {
            var filteredEmployees = [];

            if (schedulePreset && schedulePreset.id !== 'MAIN') {

                var presetPositionCodes = _.pluck(schedulePreset['positions'], 'code');

                for (var empl in users) {
                    var employee = users[empl];
                    employee.name = [employee.first_name, employee.last_name].join(" ");

                    if (employee.positions && employee.positions.length) {

                        for (var pos in employee.positions) {
                            var position = employee.positions[pos];

                            if (presetPositionCodes.indexOf(position.code) > -1) {
                                filteredEmployees.push(employee);
                                break;
                            }

                        }
                    }
                }
            } else {
                filteredEmployees = angular.copy(users);
            }

            return filteredEmployees;
        }

        var addRoleDayToRole = function (role, roleDay) {
            var newRoleDayId = roleDay.id;
            var add = true;

            if (roleDay.note && roleDay.note.text) {
                role.hasNotes = true;
            }

            for (var i in role.role_days) {
                if (role.role_days[i].id === newRoleDayId) {
                    add = false;
                    break;
                }
            }

            if (add) {
                role.role_days.push(roleDay);
            }
        };


        var addAssigneeToRoleDay = function (roleDay, assignee) {
            var newAssigneeId = assignee.id;
            var add = true;

            for (var i in roleDay.assignees) {
                if (roleDay.assignees[i].id === newAssigneeId) {
                    add = false;
                    break;
                }
            }

            if (add) {
                roleDay.assignees.push(assignee);
            }
        };

        self.setGoodFaithEstimateSettings = function (goodFaithEstimateSettings) {
            gfeSettings = goodFaithEstimateSettings;
        };

        self.getGoodFaithEstimateSettings = function () {
            return gfeSettings;
        }

        self.parseGoodFaithEstimateUsersIntervals = function (goodFaithEstimateUsers) {
            self.gfeUsersIntervals = {};
            var dayOpen = shiftTemplateUtils.secondsToTimeObj(self.dayOpenHour / 1000);
            var isNYSateRulesEnabled = gfeSettings && gfeSettings['settings'] && gfeSettings['settings']['state'] === 'NY';

            if (goodFaithEstimateUsers['users'] && goodFaithEstimateUsers['users'].length) {
                for (var i in goodFaithEstimateUsers['users']) {
                    var gfeUser = goodFaithEstimateUsers['users'][i];
                    self.gfeUsersIntervals[gfeUser.id] = {
                        effective_start_date: moment(gfeUser['effective_start_date']).valueOf(),
                        intervals: []
                    };

                    for (var j in gfeUser.intervals) {
                        var gfeInterval = gfeUser.intervals[j];
                        var dayOpenTime = moment(gfeInterval.start_time).hours(dayOpen.hours).minutes(dayOpen.minutes).valueOf();
                        gfeInterval.type = 'GFE_INTERVAL';
                        gfeInterval.checkBrandId = !!isNYSateRulesEnabled;
                        gfeInterval.start_time = moment(gfeInterval.start_time).valueOf();
                        gfeInterval.end_time = moment(gfeInterval.end_time).valueOf();

                        if (gfeInterval.start_time < dayOpenTime) {
                            gfeInterval.start_time += 24 * HOUR;
                        }

                        if (gfeInterval.end_time <= gfeInterval.start_time) {
                            gfeInterval.end_time += 24 * HOUR;
                        }

                        if (gfeInterval.start_time >= self.gfeUsersIntervals[gfeUser.id].effective_start_date) {
                            self.gfeUsersIntervals[gfeUser.id]['intervals'].push(gfeInterval);
                        }
                    }
                }
            }
        };

        self.parseAvailabilities = function (availabilities) {
            self.availabitlies = {};
            self.definedAvailabilities = {};
            self.brandHolidays = {};

            if (availabilities['intervals']) {
                for (var i in availabilities['intervals']) {
                    var availability = availabilities['intervals'][i];
                    availability.start_time = moment(availability.start_time).valueOf();
                    availability.end_time = moment(availability.end_time).valueOf();

                    if (availability.end_time <= availability.start_time) {
                        availability.end_time += 24 * HOUR;
                    }
                    self.availabitlies[availability.user_id] = self.availabitlies[availability.user_id] || [];
                    self.availabitlies[availability.user_id].push(availability);
                    if (['WORKABLE', 'AVAILABILITY', 'PREFERRED_TIME'].indexOf(availability.type) > -1) {
                        self.definedAvailabilities[availability.user_id] = self.definedAvailabilities[availability.user_id] || [];
                        self.definedAvailabilities[availability.user_id].push(availability);
                    }
                }
            }

            if (availabilities['brand_days']) {
                for (var i in availabilities['brand_days']) {
                    for (var j in availabilities['brand_days'][i].intervals) {
                        var availability = availabilities['brand_days'][i].intervals[j];
                        availability.type = availabilities['brand_days'][i].type;
                        availability.startTime = availability.start_time;
                        availability.endTime = availability.end_time;
                        availability.start_time = moment(availability.startTime).valueOf();
                        availability.end_time = moment(availability.endTime).valueOf();

                        if (availability.end_time <= availability.start_time) {
                            availability.end_time += 24 * HOUR;
                        }

                        if (availabilities['brand_days'][i].user_ids) {
                            for (var k in availabilities['brand_days'][i].user_ids) {
                                self.availabitlies[availabilities['brand_days'][i].user_ids[k]] = self.availabitlies[availabilities['brand_days'][i].user_ids[k]] || [];
                                self.availabitlies[availabilities['brand_days'][i].user_ids[k]].push(availability);
                                if (['WORKABLE', 'AVAILABILITY', 'PREFERRED_TIME'].indexOf(availability.type) > -1) {
                                    self.definedAvailabilities[availabilities['brand_days'][i].user_ids[k]] = self.definedAvailabilities[availabilities['brand_days'][i].user_ids[k]] || [];
                                    self.definedAvailabilities[availabilities['brand_days'][i].user_ids[k]].push(availability);
                                }
                            }
                        }
                        else {
                            self.availabitlies['ALL'] = self.availabitlies['ALL'] || [];
                            self.availabitlies['ALL'].push(availability);
                        }
                        if (['REGULAR_HOLIDAY', 'SPECIAL_NON_WORKING_DAY', 'STATUTORY_HOLIDAY', 'COMPANY_HOLIDAY'].indexOf(availability.type) > -1) {
                            var holiday = {
                                start_time: availability.startTime,
                                end_time: availability.endTime
                            }
                            var datesBetweenStartAndEndDate = getHolidayDates(holiday);
                            for (var d in datesBetweenStartAndEndDate) {
                                var date = datesBetweenStartAndEndDate[d];
                                self.brandHolidays[date] = self.brandHolidays[date] || {};
                                self.brandHolidays[date][availability.type] = availability;
                            }
                        }
                    }
                }
            }
        };
        var getHolidayDates = function (holiday) {
            var start = moment(holiday.start_time);
            var end = moment(holiday.end_time);
            var dates = [];

            while (start.isBefore(end)) {
                dates.push(start.format('MMM DD, YYYY'));
                start.add(1, 'day');
            }
            return dates;

        };

        /**
         * @public
         * @type function
         * @memberOf ScheduleDataServiceV2#parseShiftsTemplates
         * @param {Array} templates
         * @return undefined
         */
        self.parseShiftsTemplates = function (templates) {
            self.originalTemplates = angular.copy(templates);
            self.shiftsTemplates = {};
            self.shiftsTemplatesArray = [];

            for (var i in templates) {
                var template = templates[i];
                var shiftIntervals = [];

                for (var j in template.intervals) {
                    var interval = template.intervals[j];
                    interval.period = shiftTemplateUtils.getPeriod(interval.start_time, interval.end_time);

                    shiftIntervals.push({
                        start_time: interval.period.start,
                        end_time: interval.period.end
                    });
                }

                var intervals = brandBusinessDayUtils.normalizeTimeIntervals(shiftIntervals, self.dayOpenHour);
                var timeBreakObj = shiftTemplateUtils.getTimeBreaksObj(intervals, true);
                template.breaks = template.breaks.concat(timeBreakObj.breaks);

                template.start_time = timeBreakObj.start_time;
                template.end_time = timeBreakObj.end_time;

                template.period = shiftTemplateUtils.getPeriod(timeBreakObj.start_time, timeBreakObj.end_time);

                if ((template.start_time * 1000) < self.dayOpenHour) {
                    template.start_time += parseInt((24 * HOUR) / 1000);
                    template.end_time += parseInt((24 * HOUR) / 1000);
                }

                template.duration = shiftTemplateUtils.getShiftDuration(shiftIntervals);

                for (var b in template.breaks) {
                    if (template.breaks[b]["type"] === "UNPAID") {
                        template.duration -= (template.breaks[b]["duration"] / 3600);
                    }
                }

                template.duration = parseFloat((template.duration).toFixed(2));
                self.shiftsTemplates[template.code] = template;

                if (template['status'] === 'ACTIVE') {
                    self.shiftsTemplatesArray.push(template);
                }
            }
        };

        self.getRoleFromPosition = function (positionCode) {
            for (var i in self.flatData['roles']) {
                if (self.flatData['roles'][i].position.code === positionCode) {
                    return self.flatData['roles'][i];
                }
            }
        };
        var getCalenderDays = function (startDate, endDate) {
            var date = startDate.clone(), calenderDays = [];

            while (date.isSameOrBefore(endDate)) {
                var dayPeriod = shiftTemplateUtils.getPeriod(0, 86400, date);
                var formattedDate = date.format('YYYY-MM-DD');
                calenderDays.push({
                    start_time: dayPeriod.start,
                    end_time: dayPeriod.end,
                    label: formattedDate
                });
                date.add(1, 'days');
            }
            return calenderDays;
        };

        var prepareUserShiftsForWorkingDays = function (weekType) {
            userShiftsPerWorkingDays = {};
            for (var i in self.flatData['users']) {
                var userData = self.flatData['users'][i];
                var userId = userData.id;
                if (userId !== null) {
                    var crossLocationsUsers = self.usersCrossLocationShifts;
                    var userCrossLocationShifts = crossLocationsUsers[userId] || [];
                    var shiftsWithDetails = [];
                    userShiftsPerWorkingDays[userId] = {working_days: {}};

                    for (var s in userData['shift_ids']) {
                        shiftsWithDetails.push(self.flatData['shifts'][userData['shift_ids'][s]])
                    }
                    var userShifts = angular.copy(shiftsWithDetails).concat(angular.copy(userCrossLocationShifts));
                    var startData;
                    var endDate;

                    if (workingDaysBoundaries['first_half'] && workingDaysBoundaries['second_half']) {
                        startData = moment(workingDaysBoundaries['first_half'].start_date);
                        endDate = moment(workingDaysBoundaries['second_half'].end_date);
                    }
                    else {
                        startData = moment(self.startDate);
                        endDate = moment(self.startDate).clone().add(6,'d');
                    }

                    var calenderWorkingDays = getCalenderDays(startData, endDate);
                    var firstDayOfCurrentWeek = moment(self.startDate).clone().format('YYYY-MM-DD');
                    var firstDayOfNextWeek = moment(self.startDate).clone().add(1, 'w').format('YYYY-MM-DD');

                    for (var d = 0; d < calenderWorkingDays.length; d++) {
                        var currentDay = calenderWorkingDays[d];
                        var nextDay = calenderWorkingDays[d + 1];
                        var date = calenderWorkingDays[d].label;
                        userShiftsPerWorkingDays[userId]['working_days'][date] = userShiftsPerWorkingDays[userId]['working_days'][date] || {
                            shifts: [],
                            first_and_last_assignee_shifts: {}
                        };

                        if (date === firstDayOfCurrentWeek) {
                            var missingShiftsInFirstWeekDay = previousCalendarWeekShifts[userId] &&
                                previousCalendarWeekShifts[userId]['working_days'] &&
                                previousCalendarWeekShifts[userId]['working_days'][firstDayOfCurrentWeek];

                            if (missingShiftsInFirstWeekDay) {
                                if (!_.isEmpty(missingShiftsInFirstWeekDay['first_assignee_shift'])) {
                                    userShiftsPerWorkingDays[userId]['working_days'][date].shifts.push(missingShiftsInFirstWeekDay['first_assignee_shift']);
                                }
                                if (!_.isEmpty(missingShiftsInFirstWeekDay['last_assignee_shift']) &&
                                    missingShiftsInFirstWeekDay['first_assignee_shift'].id !== missingShiftsInFirstWeekDay['last_assignee_shift'].id) {
                                    userShiftsPerWorkingDays[userId]['working_days'][date].shifts.push(missingShiftsInFirstWeekDay['last_assignee_shift']);
                                }
                            }
                        }
                        if (date === firstDayOfNextWeek) {
                            var missingShiftsInLastWeekDay = nextCalendarWeekShifts[userId] &&
                                nextCalendarWeekShifts[userId]['working_days'] &&
                                nextCalendarWeekShifts[userId]['working_days'][firstDayOfNextWeek];

                            if (missingShiftsInLastWeekDay) {
                                if (!_.isEmpty(missingShiftsInLastWeekDay['first_assignee_shift'])) {
                                    userShiftsPerWorkingDays[userId]['working_days'][date].shifts.push(missingShiftsInLastWeekDay['first_assignee_shift']);
                                }
                                if (!_.isEmpty(missingShiftsInLastWeekDay['last_assignee_shift']) &&
                                    missingShiftsInLastWeekDay['first_assignee_shift'].id !== missingShiftsInLastWeekDay['last_assignee_shift'].id) {
                                    userShiftsPerWorkingDays[userId]['working_days'][date].shifts.push(missingShiftsInLastWeekDay['last_assignee_shift']);
                                }
                            }
                        }

                        for (var sh in userShifts) {
                            var shiftDetails = angular.copy(userShifts[sh]);
                                if (weekType === 'CALENDAR') {
                                    if (moment(shiftDetails.start_time).clone().format('YYYY-MM-DD') === date) {
                                        if (moment(shiftDetails.end_time).isSameOrBefore(currentDay.end_time)) {
                                            userShiftsPerWorkingDays[userId]['working_days'][currentDay.label].shifts.push({
                                                start_time: shiftDetails.start_time,
                                                end_time: shiftDetails.end_time,
                                                id: shiftDetails.id,
                                                day: moment(currentDay.label).format('MMM DD, YYYY')
                                            })
                                        } else {
                                            userShiftsPerWorkingDays[userId]['working_days'][currentDay.label].shifts.push({
                                                start_time: shiftDetails.start_time,
                                                end_time: moment(currentDay.end_time).format('MMM DD, YYYY HH:mm'),
                                                id: shiftDetails.id,
                                                day: moment(currentDay.label).format('MMM DD, YYYY')
                                            });
                                            if (nextDay) {
                                                userShiftsPerWorkingDays[userId]['working_days'][nextDay.label] = userShiftsPerWorkingDays[userId]['working_days'][nextDay.label] || {shifts: [], first_and_last_assignee_shifts: {}};
                                                userShiftsPerWorkingDays[userId]['working_days'][nextDay.label].shifts.push({
                                                    start_time: moment(nextDay.start_time).format('MMM DD, YYYY HH:mm'),
                                                    end_time: shiftDetails.end_time,
                                                    id: shiftDetails.id,
                                                    day: moment(nextDay.label).format('MMM DD, YYYY')
                                                });
                                            }
                                        }
                                    }
                                }
                                else if (weekType === 'BUSINESS') {
                                    var shiftDay = moment(shiftDetails.day).format('YYYY-MM-DD');
                                    var businessDayEndTime = moment(shiftDay, 'YYYY-MM-DD').valueOf() + self.dayCloseHour;

                                    if (shiftDay === date) {
                                        if (moment(shiftDetails.end_time).valueOf() > businessDayEndTime) {
                                            userShiftsPerWorkingDays[userId]['working_days'][date].shifts.push({
                                                start_time: shiftDetails.start_time,
                                                end_time: moment(businessDayEndTime).format("MMM DD, YYYY HH:mm"),
                                                id: shiftDetails.id,
                                                day: moment(date).format('MMM DD, YYYY')
                                            })

                                            if (nextDay) {
                                                userShiftsPerWorkingDays[userId]['working_days'][nextDay.label] = userShiftsPerWorkingDays[userId]['working_days'][nextDay.label] || {shifts: [], first_and_last_assignee_shifts: {}};
                                                userShiftsPerWorkingDays[userId]['working_days'][nextDay.label].shifts.push({
                                                    start_time: moment(businessDayEndTime),
                                                    end_time: shiftDetails.end_time,
                                                    id: shiftDetails.id,
                                                    day: moment(nextDay.label).format('MMM DD, YYYY')
                                                })
                                            }
                                        }
                                        else {
                                            userShiftsPerWorkingDays[userId]['working_days'][date].shifts.push({
                                                start_time: shiftDetails.start_time,
                                                end_time: shiftDetails.end_time,
                                                id: shiftDetails.id,
                                                day: moment(date).format('MMM DD, YYYY')
                                            })
                                        }
                                    }
                                }
                        }
                        userShiftsPerWorkingDays[userId]['working_days'][date].first_and_last_assignee_shifts = mapFirstAndLastAssigneeShiftsForDay(userId,date);
                    }
                }
            }
        };
        var mapFirstAndLastAssigneeShiftsForDay = function (userId, date) {
            if (userShiftsPerWorkingDays[userId]['working_days'][date].shifts.length) {
                var dayShifts = userShiftsPerWorkingDays[userId]['working_days'][date].shifts;
                return geFirstAndLastAssigneeShift(dayShifts);
            }
            else if (previousCalendarWeekShifts[userId] &&
                previousCalendarWeekShifts[userId]['working_days'] &&
                previousCalendarWeekShifts[userId]['working_days'][date]) {
                return  angular.copy(previousCalendarWeekShifts[userId]['working_days'][date]);
            }
            else if (nextCalendarWeekShifts[userId] &&
                nextCalendarWeekShifts[userId]['working_days'] &&
                nextCalendarWeekShifts[userId]['working_days'][date]) {
                return angular.copy(nextCalendarWeekShifts[userId]['working_days'][date]);
            }
            return {
                first_assignee_shift: {},
                last_assignee_shift:{}
            }
        }

        var geFirstAndLastAssigneeShift = function (dayShifts) {
            var firstAndLastAssignShiftsPerDay = {};
            for (var j in dayShifts) {
                var shiftDetails = dayShifts[j];

                if (_.isEmpty(firstAndLastAssignShiftsPerDay['first_assignee_shift'])) {
                    firstAndLastAssignShiftsPerDay['first_assignee_shift'] = shiftDetails;
                } else {
                    var shiftStartTime = moment(shiftDetails.start_time);
                    var referenceShift = firstAndLastAssignShiftsPerDay['first_assignee_shift'];

                    if ((shiftStartTime.isBefore(moment(referenceShift.start_time)))) {
                        firstAndLastAssignShiftsPerDay['first_assignee_shift'] = shiftDetails;
                    }
                }

                if (_.isEmpty(firstAndLastAssignShiftsPerDay['last_assignee_shift'])) {
                    firstAndLastAssignShiftsPerDay['last_assignee_shift'] = shiftDetails;
                } else {
                    var shiftEndTime = moment(shiftDetails.end_time);
                    var referenceShift = firstAndLastAssignShiftsPerDay['last_assignee_shift'];
                    if ((shiftEndTime.isAfter(moment(referenceShift.end_time)))) {
                        firstAndLastAssignShiftsPerDay['last_assignee_shift'] = shiftDetails;
                    }
                }
            }

            return firstAndLastAssignShiftsPerDay;
        };

        var setCalenderWorkingDaysBoundaries = function (firstDayInFirstHalf, firstDayInSecondHalf) {
            workingDaysBoundaries = {
                first_half: {start_date: firstDayInFirstHalf, end_date: moment(firstDayInFirstHalf).clone().add(6,'d').format('YYYY-MM-DD')},
                second_half: {start_date: firstDayInSecondHalf, end_date: moment(firstDayInSecondHalf).clone().add(6,'d').format('YYYY-MM-DD')}
            };
        }

        self.getCalenderWorkingDaysBoundaries = function () {
            return workingDaysBoundaries;
        }

        self.getShiftsForWeek = function (userId, weekDates) {
            var shiftsPerDate = {};
            for (var i in weekDates) {
                var date = weekDates[i];
                var userShifts = userShiftsPerWorkingDays[userId] &&
                    userShiftsPerWorkingDays[userId]['working_days'] &&
                    userShiftsPerWorkingDays[userId]['working_days'][date];
                if (userShifts) {
                    shiftsPerDate[date] = angular.copy(userShifts.first_and_last_assignee_shifts);
                }
            }
            return shiftsPerDate;
        }

        self.preparePreviousAndNextExtraWorkingDaysShifts = function (previousDays, nextDays) {
            previousCalendarWeekShifts = formatShiftsForExtraWorkingDays(previousDays);
            nextCalendarWeekShifts = formatShiftsForExtraWorkingDays(nextDays);
        };
        var formatShiftsForExtraWorkingDays = function (users) {
            var calendarWeekShifts = {};
            var maxScheduleDaySettings = settings['schedule'] && settings['schedule']['max_scheduled_days'] || {};
            var weekType = maxScheduleDaySettings['schedule_max_working_days_week_type'];

            for (var i in users) {
                var user = users[i];
                calendarWeekShifts[user.id] = {working_days: {}};
                for (var j = 0; j < user['working_days'].length; j++) {
                    var workingDay = user['working_days'][j];

                    calendarWeekShifts[user.id]['working_days'][workingDay.date] = {
                        first_assignee_shift: workingDay.first_assignee_shift || {},
                        last_assignee_shift: workingDay.last_assignee_shift || {}
                    }
                }

                for (var d in calendarWeekShifts[user.id]['working_days']) {
                    var currentWorkingDay = calendarWeekShifts[user.id]['working_days'][d];
                    var currentDay = {
                        start_time: moment(d).clone().startOf('day'),
                        end_time: moment(d).add(1, 'd').clone().startOf('day')
                    };

                    if (weekType === 'BUSINESS') {
                        var duration = moment.duration(self.dayOpenHour);
                        var hours = duration.hours();
                        var minutes = duration.minutes();

                        currentDay.start_time.set('hour', hours).set('minute', minutes);
                        currentDay.end_time.set('hour', hours).set('minute', minutes);
                    }

                    if (!_.isEmpty(currentWorkingDay.first_assignee_shift) || !_.isEmpty(currentWorkingDay.last_assignee_shift)) {
                        currentWorkingDay.last_assignee_shift['day'] = moment(d).format('MMM DD, YYYY');
                        currentWorkingDay.first_assignee_shift['day'] = moment(d).format('MMM DD, YYYY');

                        if (moment(currentWorkingDay.last_assignee_shift.end_time).isAfter(currentDay.end_time)) {

                            var shiftDetails = angular.copy(currentWorkingDay.last_assignee_shift);
                            currentWorkingDay.last_assignee_shift['end_time'] = currentDay.end_time.format('YYYY-MM-DDTHH:mm');

                            if (currentWorkingDay.first_assignee_shift && currentWorkingDay.first_assignee_shift.id === shiftDetails.id) {
                                currentWorkingDay.first_assignee_shift = angular.copy(currentWorkingDay.last_assignee_shift);
                            }
                            var nextCalenderDay = moment(d).add(1, 'd').format('YYYY-MM-DD');
                            calendarWeekShifts[user.id]['working_days'][nextCalenderDay] = calendarWeekShifts[user.id]['working_days'][nextCalenderDay] || {
                                first_assignee_shift: {},
                                last_assignee_shift: {}
                            };

                            if (calendarWeekShifts[user.id]['working_days'][nextCalenderDay]) {
                                calendarWeekShifts[user.id]['working_days'][nextCalenderDay].first_assignee_shift = {
                                    start_time: currentDay.end_time.format('YYYY-MM-DDTHH:mm'),
                                    end_time: shiftDetails.end_time,
                                    id: shiftDetails.id,
                                    day: moment(nextCalenderDay).format('MMM DD, YYYY')
                                }
                                if (_.isEmpty(calendarWeekShifts[user.id]['working_days'][nextCalenderDay].last_assignee_shift)) {
                                    calendarWeekShifts[user.id]['working_days'][nextCalenderDay].last_assignee_shift = angular.copy(calendarWeekShifts[user.id]['working_days'][nextCalenderDay].first_assignee_shift);
                                }
                            }
                        }
                    }
                }
            }
            return calendarWeekShifts;
        };

        self.updateCrossScheduleBrandIds = function (crossSchedules) {
            for (var i = 0; i < crossSchedules.length; i++) {
                var scheduleItem = crossSchedules[i];
                var isBrandAlreadyPushed = crossScheduleBrandIds.indexOf(scheduleItem.brand_id) !== -1;
                if (!isBrandAlreadyPushed) {
                    crossScheduleBrandIds.push(scheduleItem.brand_id);
                }
            }
        }

        self.getCrossScheduleBrandIds = function () {
            return crossScheduleBrandIds;
        }

        self.getCrossScheduleUsers = () => {
            let users = {};

            for (const brandId in self.crossFlatData) {
                const brandFlatData = self.crossFlatData[brandId];
                users = {
                    ...users,
                    ...brandFlatData.users
                }
            }

            return users;
;        }

        self.parseCrossBrandShifts = function (crossSchedules, brands) {
            var isOvernightShiftSettingsEnabled = self.checkOvernightShiftsSettings(self.startDate);
            self.crossFlatData = {};
            self.crossMappings = {};
            self.usersCrossLocationShifts = {};

            for (var cs in crossSchedules) {
                var rawScheduleData = $.extend({}, crossSchedules[cs]);
                self.crossFlatData[rawScheduleData['brand_id']] = self.crossFlatData[rawScheduleData['brand_id']] || {
                    roles: {},
                    roleDays: {},
                    assignees: {},
                    shifts: {},
                    users: {},
                    days: {},
                    brand: {},
                    extended_shifts: {},
                    extended_days: {}
                };
                self.crossMappings[rawScheduleData['brand_id']] = self.crossMappings[rawScheduleData['brand_id']] || {
                    day_role: {}, // roleDay.id
                    user_roleday: {}, // assignee.id
                    roleday_position: {}, // position object
                    day_user: {} // [assignee_ids]
                };

                self.crossFlatData[rawScheduleData['brand_id']]['brand'] = _.findWhere(brands, {id: rawScheduleData['brand_id']});

                for (var i in rawScheduleData.roles) {
                    var role = rawScheduleData.roles[i];
                    self.crossFlatData[rawScheduleData['brand_id']]['roles'][role.id] = self.crossFlatData[rawScheduleData['brand_id']]['roles'][role.id] || role;
                    self.crossFlatData[rawScheduleData['brand_id']]['roles'][role.id]['assignee_ids'] = self.crossFlatData[rawScheduleData['brand_id']]['roles'][role.id]['assignee_ids'] || [];
                    self.crossFlatData[rawScheduleData['brand_id']]['roles'][role.id]['user_ids'] = self.crossFlatData[rawScheduleData['brand_id']]['roles'][role.id]['user_ids'] || [];

                    for (var j in role.role_days) {
                        var roleDay = role.role_days[j];
                        roleDay['role_id'] = role.id;

                        self.crossFlatData[rawScheduleData['brand_id']]['roleDays'][roleDay.id] = self.crossFlatData[rawScheduleData['brand_id']]['roleDays'][roleDay.id] || roleDay;

                        self.crossMappings[rawScheduleData['brand_id']]['roleday_position'][roleDay.id] = self.crossFlatData[rawScheduleData['brand_id']]['roles'][role.id].position;

                        self.crossFlatData[rawScheduleData['brand_id']]['days'][roleDay.date] = self.crossFlatData[rawScheduleData['brand_id']]['days'][roleDay.date] || {
                                'id': roleDay.date,
                                'roleday_ids': [],
                                'role_ids': [],
                                'user_ids': []
                            };
                        var day = self.crossFlatData[rawScheduleData['brand_id']]['days'][roleDay.date];

                        self.crossMappings[rawScheduleData['brand_id']]['day_role'][day.id + "_" + role.id] = roleDay.id;

                        (day['roleday_ids'].indexOf(roleDay.id) == -1) && day['roleday_ids'].push(roleDay.id);
                        (day['role_ids'].indexOf(role.id) == -1) && day['role_ids'].push(role.id);

                        for (var k in roleDay.assignees) {
                            var assignee = roleDay.assignees[k];
                            assignee.roleday_id = roleDay.id;
                            assignee.role_id = role.id;

                            self.crossFlatData[rawScheduleData['brand_id']]['users'][assignee.user_id] = self.crossFlatData[rawScheduleData['brand_id']]['users'][assignee.user_id] || {
                                    'id': assignee.user_id,
                                    'assignee_ids': [],
                                    'role_ids': [],
                                    'roleday_ids': [],
                                    'shift_ids': []
                                };
                            var user = self.crossFlatData[rawScheduleData['brand_id']]['users'][assignee.user_id];

                            if (!self.crossMappings[rawScheduleData['brand_id']]['day_user'][day.id + "_" + user.id]) {
                                self.crossMappings[rawScheduleData['brand_id']]['day_user'][day.id + "_" + user.id] = [];
                            }

                            self.crossMappings[rawScheduleData['brand_id']]['user_roleday'][user.id + "_" + roleDay.id] = assignee.id;
                            (self.crossMappings[rawScheduleData['brand_id']]['day_user'][day.id + "_" + user.id].indexOf(assignee.id) == -1) && self.crossMappings[rawScheduleData['brand_id']]['day_user'][day.id + "_" + user.id].push(assignee.id);

                            for (var l in assignee.assignee_shifts) {
                                var shift = assignee.assignee_shifts[l];
                                shift['role_id'] = role.id;
                                shift['roleday_id'] = roleDay.id;
                                shift['assignee_id'] = assignee.id;
                                shift['user_id'] = user.id;
                                shift['day'] = day.id;
                                shift['brand_id'] = rawScheduleData['brand_id'];
                                shift['cross_location'] = true;
                                shift['breaks'] = shift['breaks'] || [];
                                shift['position'] = role.position;

                                self.crossFlatData[rawScheduleData['brand_id']]['shifts'][shift.id] = shift;
                                user['shift_ids'].push(shift.id);

                                self.usersCrossLocationShifts[shift['user_id']] = self.usersCrossLocationShifts[shift['user_id']] || [];
                                self.usersCrossLocationShifts[shift['user_id']].push(shift);
                            }

                            if (self.crossFlatData[rawScheduleData['brand_id']]['assignees'][assignee.id]) {
                                self.crossFlatData[rawScheduleData['brand_id']]['assignees'][assignee.id].assignee_shifts = self.crossFlatData[rawScheduleData['brand_id']]['assignees'][assignee.id].assignee_shifts.concat(assignee.assignee_shifts);
                            }
                            else {
                                self.crossFlatData[rawScheduleData['brand_id']]['assignees'][assignee.id] = assignee;
                            }

                            addAssigneeToRoleDay(self.crossFlatData[rawScheduleData['brand_id']]['roleDays'][roleDay.id], assignee);

                            (self.crossFlatData[rawScheduleData['brand_id']]['users'][user.id]['assignee_ids'].indexOf(assignee.id) == -1) && self.crossFlatData[rawScheduleData['brand_id']]['users'][user.id]['assignee_ids'].push(assignee.id);
                            (self.crossFlatData[rawScheduleData['brand_id']]['roles'][role.id]['assignee_ids'].indexOf(assignee.id) == -1) && self.crossFlatData[rawScheduleData['brand_id']]['roles'][role.id]['assignee_ids'].push(assignee.id);
                            (self.crossFlatData[rawScheduleData['brand_id']]['users'][user.id]['roleday_ids'].indexOf(roleDay.id) == -1) && self.crossFlatData[rawScheduleData['brand_id']]['users'][user.id]['roleday_ids'].push(roleDay.id);
                            (self.crossFlatData[rawScheduleData['brand_id']]['users'][user.id]['role_ids'].indexOf(role.id) == -1) && self.crossFlatData[rawScheduleData['brand_id']]['users'][user.id]['role_ids'].push(role.id);
                            (self.crossFlatData[rawScheduleData['brand_id']]['roles'][role.id]['user_ids'].indexOf(user.id) == -1) && self.crossFlatData[rawScheduleData['brand_id']]['roles'][role.id]['user_ids'].push(user.id);
                            (day['user_ids'].indexOf(user.id) == -1) && day['user_ids'].push(user.id);
                        }

                        addRoleDayToRole(self.crossFlatData[rawScheduleData['brand_id']]['roles'][role.id], self.crossFlatData[rawScheduleData['brand_id']]['roleDays'][roleDay.id]);
                    }
                }
            }

            if (isOvernightShiftSettingsEnabled) {
                for (var brandId in self.crossFlatData) {
                    var brandCrossFlatData = self.crossFlatData[brandId];
                    var extendedData = calculateScheduleExtendedShifts(brandCrossFlatData['roleDays'] || {});
                    brandCrossFlatData['extended_shifts'] = extendedData['extended_shifts'];
                    brandCrossFlatData['extended_days'] = extendedData['extended_days'];
                }
            }
        };

        self.getRowScheduleForShifts = function (shiftIds) {
            var schedule = {roles: []};

            for (var i in shiftIds) {
                var shiftId = shiftIds[i];
                var shift = self.flatData['shifts'][shiftId];
                var roleId = shift['role_id'];
                var roleDayId = shift['roleday_id'];
                var assigneeId = shift['assignee_id'];

                var role = _.findWhere(schedule['roles'], {id: roleId});

                if (!role) {
                    role = {id: roleId, role_days:[]};
                    schedule['roles'].push(role);
                }

                var roleDay = _.findWhere(role['role_days'], {id: roleDayId});

                if (!roleDay) {
                    roleDay = {id: roleDayId, assignees:[]};
                    role['role_days'].push(roleDay);
                }

                var assignee = _.findWhere(roleDay['assignees'], {id: assigneeId});

                if (!assignee) {
                    assignee = {id: assigneeId, assignee_shifts:[]};
                    roleDay['assignees'].push(assignee);
                }

                assignee['assignee_shifts'].push({id: shiftId})
            }

            return schedule;
        };

        self.checkIfHasWeeklyPendingConsents = function () {
            var hasWeeklyPendingConsents = false;

            for (var i in self.flatData['shifts']) {
                var shift = self.flatData['shifts'][i];
                if (shift && shift.isPendingEmployeeConsent) {
                    hasWeeklyPendingConsents = true;
                    break;
                }
            }

            return hasWeeklyPendingConsents;
        };

        self.isSchedulePublished = function (day) {
            var isSchedulePublished = false;

            for (var i in self.flatData['shifts']) {
                var shift = self.flatData['shifts'][i];

                if (day && shift['day'] !== day) {
                    continue;
                }

                if (['DELETED', 'PUBLISHED', 'PUBLISHED_EDITED'].indexOf(shift.status) > -1) {
                    isSchedulePublished = true;
                    break;
                }
            }

            return isSchedulePublished;
        };

        self.setExtraPaySettings = (settings) => {
            extraPaySettings = settings;
        };

        self.getExtraPaySettings = () => {
            return extraPaySettings;
        };

        self.setScheduleWarningsConfiguration = function (scheduleWarningsConfig) {
            self.scheduleWarningsConfiguration = scheduleWarningsConfig;
        };

        self.setActiveScheduleDay = function (day) {
            self.activeScheduleDay = moment(day).format('MMM DD, YYYY');
        };

        self.getActiveScheduleDay = function () {
            return self.activeScheduleDay;
        };

        self.setActiveScheduleViewType = function (viewType) {
            self.activeScheduleViewType = viewType;
        };

        self.getActiveScheduleViewType = function () {
            return self.activeScheduleViewType;
        };

        self.setDayNotes = function (notes) {
            var dayNoteMap = {};
            for (var i in notes) {
                dayNoteMap[notes[i].date] = notes[i];
            }
            dayNotes = dayNoteMap;
        }

        self.openManageDayNotesModal = function (day, isScheduleLocked, canManageSchedule, cb) {

            var modalData = function () {
                return {
                    note: self.getDayNote(day),
                    day: day,
                    canManageSchedule: canManageSchedule,
                    isScheduleLocked: isScheduleLocked,
                };
            }

            var onSave = function () {
                return function () {
                    cb && cb(self.getDayNote(day));
                }
            }

            _modal({
                controller: 'AddEditScheduleDayNotesModalController',
                controllerAs: '$ctrl',
                templateUrl: '../modules/team_schedule/employer/schedule/modals/add-edit-schedule-day-notes/add-edit-schedule-day-notes.modal.html',
                show: true,
                backdrop: 'static',
                resolve: {
                    modalData: modalData,
                    onSave: onSave,
                }
            });
        }

        self.getDayNotes = function () {
            return dayNotes;
        }

        self.getDayNote = function (day) {
            return dayNotes && dayNotes[day.format('YYYY-MM-DD')];
        }

        self.deleteDayNote = function (day) {
            delete dayNotes[day.format('YYYY-MM-DD')];
        }

        self.updateDayNote = function (day, updatedNote) {
            dayNotes[day.format('YYYY-MM-DD')] = updatedNote;
        }

        self.isShiftBeforeCurrentBrandTimezone = function (shift) {
            if (self.isPastScheduleUpdatesEnabled && self.checkIsRunningWeek()) {
                return false;
            }

            var shiftDayEndTime = moment(shift.day).add(self.dayCloseHour, 'milliseconds').add(self.dayCloseHourExtension, 'milliseconds');

            return shiftDayEndTime.isSameOrBefore(self.currentOpenTimeInBrandTimezone);
        }

        self.checkLockedWeek = function (selectedDate) {
            if (self.isPastScheduleUpdatesEnabled && self.checkIsRunningWeek()) {
                return false;
            }

            var isRunningWeek = self.checkIsRunningWeek();
            var brand = teamScheduleService.getBrandById(self.brandId);
            var nowInBrandTimezone = moment(Utils.getNowInBrandTimezoneByTimeZoneName(brand.timezoneName).format("YYYY-MM-DDTHH:mm:ss"));
            var firstDayOfWeek = Utils.getWeekStart(moment(selectedDate), brand.startDayOfWeek).format("MMM DD, YYYY");
            var businessDay = teamScheduleService.getBusinessDay(firstDayOfWeek);
            var closeFirstDayOfWeek = moment(firstDayOfWeek).add(businessDay['close_time'], 'milliseconds');

            return isRunningWeek && nowInBrandTimezone.isAfter(closeFirstDayOfWeek);
        }

        self.checkLockedAssignee = function (selectedDate, viewType) {
            if (viewType == 'WEEKLY') {
                return self.checkLockedWeek(selectedDate);
            } else {
                return self.beforeNowInBrandTimezone;
            }
        }

        self.setPastScheduleUpdatesEnabled = function (isPastScheduleUpdatesEnabled) {
            self.isPastScheduleUpdatesEnabled = isPastScheduleUpdatesEnabled;
        };

        self.setShiftAssignmentsAcrossDifferentPositionsSetting = (isShiftAssignmentsAcrossDifferentPositionsSettingEnabled) => {
             isShiftAssignmentsAcrossDifferentPositionsEnabled = isShiftAssignmentsAcrossDifferentPositionsSettingEnabled;
        };

        self.getShiftAssignmentsAcrossDifferentPositionsSetting = () => {
            return isShiftAssignmentsAcrossDifferentPositionsEnabled;
        }

        self.checkIsRunningWeek = function () {
            var endDay = moment(self.startDate, "MMM DD, YYYY").add(6, 'days');
            var businessDay = teamScheduleService.getBusinessDay(endDay);
            var startDate = moment(self.startDate, "MMM DD, YYYY").valueOf() + businessDay['open_time'];
            var endDate = endDay.valueOf() + businessDay['close_time'];
            var currentDate = new Date();

            return moment(currentDate).isSameOrAfter(moment(startDate)) && moment(currentDate).isSameOrBefore(moment(endDate));
        }

        self.checkIfUserScheduled = function (userId) {
            return (
                self.flatData.users[userId] &&
                self.flatData.users[userId]['shift_ids'] &&
                self.flatData.users[userId]['shift_ids'].length
            );
        };

        /**
         * This function to loop through all shifts we have and calculate the publish button status.
         * This needs for implicit publish because some shifts when deleted need to published to employee implicit from the BE.
         * So we need to check the whole shifts for the schedule to show the following cases:
         * - If we don't have any published shifts so the status will be UNPUBLISHED.
         * - If we don't have any any un published shifts and all of the other shifts is published the status will be PUBLISHED
         * - If we have mix from publish and un-published shifts the status will be PARTIALLY_PUBLISHED
         * - Finally if there is any shifts on the schedule the status will be UNPUBLISHED
         *
         * @return {*|String}
         */
        self.calculatePublishStatus = function () {
            var statusesDict = {};
            var shiftsObjectCopy = $.extend(true, {}, self.flatData['shifts']);

            for (var i in shiftsObjectCopy) {
                var shift = self.flatData['shifts'][i];

                shift.status = shift.status || TeamScheduleV2API.SCHEDULE_PUBLISH_STATUSES.UNPUBLISHED;

                var finalShiftStatus = shift.status;

                if (['DELETED', 'PUBLISHED_EDITED'].indexOf(finalShiftStatus) > -1) {
                    finalShiftStatus = TeamScheduleV2API.SCHEDULE_PUBLISH_STATUSES.UNPUBLISHED;
                }

                statusesDict[finalShiftStatus] = statusesDict[finalShiftStatus] || 0;
                statusesDict[finalShiftStatus]++;
            }

            var finalStatus;

            if (
                !statusesDict[TeamScheduleV2API.SCHEDULE_PUBLISH_STATUSES.UNPUBLISHED] &&
                statusesDict[TeamScheduleV2API.SCHEDULE_PUBLISH_STATUSES.PUBLISHED]
            ) {
                finalStatus = TeamScheduleV2API.SCHEDULE_PUBLISH_STATUSES.PUBLISHED;
            } else if (
                statusesDict[TeamScheduleV2API.SCHEDULE_PUBLISH_STATUSES.UNPUBLISHED] &&
                statusesDict[TeamScheduleV2API.SCHEDULE_PUBLISH_STATUSES.PUBLISHED]
            ) {
                finalStatus = TeamScheduleV2API.SCHEDULE_PUBLISH_STATUSES.PARTIALLY_PUBLISHED;
            } else {
                finalStatus = TeamScheduleV2API.SCHEDULE_PUBLISH_STATUSES.UNPUBLISHED;
            }

            return finalStatus;
        };

        var scheduleChangesPollingTimeout;

        self.stopPollingScheduleChanges = function () {
            clearTimeout(scheduleChangesPollingTimeout);
        };

        self.startPollingScheduleChanges = function (scheduleId) {
            var deferred = $q.defer();
            var attempts = 0;
            var params = {
                week: self.startDate,
                includeSubmissions: false,
                includeChildren: false
            };
            var getScheduleChanges = function () {
                clearTimeout(scheduleChangesPollingTimeout);
                TeamScheduleAPI.getSchedulesDetailsList(self.brandId, params)
                    .then(function (schedules) {
                        var schedule = schedules.find(function (item) {
                            return item.id === scheduleId;
                        });
                        if (schedule && schedule.publish_status === 'COMPLETED') {
                            deferred.resolve(schedule);
                        } else if (attempts > 4) {
                            deferred.reject({error: 'Exceeded max attempts'});
                        } else {
                            scheduleChangesPollingTimeout = setTimeout(getScheduleChanges, 2000);
                        }
                    })
                    .finally(function () {
                        attempts++;
                    });
            };
            getScheduleChanges();
            return deferred.promise;
        };

        self.updateScheduleShiftsConsents = function () {
            var deferred = $q.defer();
            var params = {
                status: 'PENDING_EMPLOYEE_APPROVAL',
                from_date: moment(self.startDate).format('YYYY-MM-DD'),
                to_date: moment(self.startDate).add(8, 'days').format('YYYY-MM-DD')
            };
            TeamScheduleAPI.getBrandScheduledShiftsConsents(self.brandId, params)
                .then(function (consents) {
                    for (var i in consents) {
                        var consent = consents[i];
                        if (consent.assignee_shift && self.flatData.shifts[consent.assignee_shift.reference_id]) {
                            var shift = self.flatData.shifts[consent.assignee_shift.reference_id];
                            shift.employee_consent = consent;
                            shift.isPendingEmployeeConsent = true;
                            shift.status = "PUBLISHED";
                            self.flatData.shifts[consent.assignee_shift.reference_id] = shift;
                        }
                    }
                    deferred.resolve();
                })
                .catch(function (err) {
                    deferred.reject(err);
                });
            return deferred.promise;
        };

        self.setEmployeeLatenessReasonPeriod = function (period, brandId) {
            brandId = brandId || self.brandId;
            employeeLatenessReasonPeriod[brandId] = period;
        }

        self.getEmployeeLatenessReasonsPeriod = function (brandId) {
            brandId = brandId || self.brandId;
            return employeeLatenessReasonPeriod[brandId];
        }

        self.setLatenessReasons = function (reasons, brandId) {
            var reasonsMap = {};
            for (var i in reasons) {
                reasonsMap[reasons[i]['id']] = reasons[i];
            }
            employeeLatenessReasons[brandId] = reasonsMap;
        }

        self.getLatenessReasons = function () {
            return employeeLatenessReasons[self.brandId];
        }

    };

    app.service('ScheduleDataServiceV2', [
        'ShiftTemplateUtils', 'businessDayUtils', 'TSUsersService', 'specialEventsService', 'TeamScheduleService', 'scheduleDateUtilsService', '$filter', '$modal',
        function (ShiftTemplateUtils, businessDayUtils, TSUsersService, specialEventsService, TeamScheduleService, scheduleDateUtilsService, $filter, $modal) {
            shiftTemplateUtils = ShiftTemplateUtils;
            brandBusinessDayUtils = businessDayUtils;
            teamScheduleService = TeamScheduleService;
            _specialEventsService = specialEventsService;
            _TSUsersService = TSUsersService;
            _scheduleDateUtilsService = scheduleDateUtilsService;
            _filter = $filter;
            _modal = $modal;
            return new ScheduleDataServiceV2();
        }
    ]);

})(angular.module('harriApp'));
